export default {
  list: {
    banner: {
      title: "行业解决方案",
      subtitle: "我们为不同行业和应用领域提供专业的解决方案，为企业提升生产力",
    },
    "hot-solution": {
      title: "行业解决方案",
      subtitle:
        "针对互联网、金融、政企、制造业、教育等领域需求特性，打造个性化行业解决方案。",
      "common-detial": "查看详情",
      education: {
        title: "教育",
        subtitle:
          "安全无缝的学生体验，保护学生和教职工，WiFi、校园卡、一网通行。",
      },
      game: {
        title: "游戏",
        subtitle:
          "让玩家快进来，让黑客远离点，多身份源快速登录，保证用户访问敏感信息。",
      },
      it: {
        title: "IT 科技",
        subtitle: "一次认证多点互联，一个软件全局监测。",
      },
      govenment: {
        title: "政府",
        subtitle: "让公民用一个账号访问所有系统，安全登录政务服务。",
      },
      finance: {
        title: "金融",
        subtitle: "赋能金融云，直观可视化的分析平台，符合国家监管标准。",
      },
      publisher: {
        title: "出版",
        subtitle:
          "让读者专注阅读，数亿用户在弹指间伸缩，发行、作者、编辑，尽在掌控。",
      },
      medical: {
        title: "医疗",
        subtitle:
          "Authing 采取数据加密、统一管理，为医疗机构提供标准化、一体化、开放式的医疗数据服务。",
      },
      enterprise: {
        title: "企业",
        subtitle:
          "使用 Authing 提高客户采用率、满足合规性需求、保护您的 API 并让您的企业面向未来。",
      },
    },
    "scene-solution": {
      title: "场景解决方案",
      subtitle:
        "针对互联网、金融、政企、制造业、教育等领域需求特性，打造个性化行业解决方案。",
      "common-detial": "查看详情",
      education: {
        title: "教育",
        subtitle:
          "安全无缝的学生体验，保护学生和教职工，WiFi、校园卡、一网通行。",
      },
      game: {
        title: "游戏",
        subtitle:
          "让玩家快进来，让黑客远离点，多身份源快速登录，保证用户访问敏感信息。",
      },
      it: {
        title: "IT 科技",
        subtitle: "一次认证多点互联，一个软件全局监测。",
      },
      govenment: {
        title: "政府",
        subtitle: "让公民用一个账号访问所有系统，安全登录政务服务。",
      },
      finance: {
        title: "金融",
        subtitle: "赋能金融云，直观可视化的分析平台，符合国家监管标准。",
      },
      publisher: {
        title: "出版",
        subtitle:
          "让读者专注阅读，数亿用户在弹指间伸缩，发行、作者、编辑，尽在掌控。",
      },
      medical: {
        title: "医疗",
        subtitle:
          "Authing 采取数据加密、统一管理，为医疗机构提供标准化、一体化、开放式的医疗数据服务。",
      },
    },
    customer: {
      title: "Authing 的代表客户",
    },
  },
  detail: {
    "label-medical": "医疗",
    "label-government": "政府",
    "label-education": "教育",
    "label-finance": "金融",
    "label-game": "游戏",
    "label-software": "科技",
    "label-publisher": "出版",
    "label-enterprise": "企业",
    "title-challenge": "需求挑战",
    "title-value": "方案价值",
    "button-consult": "方案咨询",
    medical: {
      title: "医疗行业解决方案",
      sub: "统一数字身份，为医疗机构提供标准化、一体化、开放式的医疗数据服务。",
      challenges: {
        "item-one": {
          title: "保护数据隐私，增强患者信任",
          content:
            "无数的医疗系统中都分散着市民的个人数据，容易造成个人信息的泄漏。《医疗卫生服务单位信息公开管理办法（试行）》自 2010 年通过之后，便规定了县级以上地方人民政府卫生、中医药行政管理部门应当建立健全医疗卫生服务单位信息公开工作责任追究制度，并对「公开不应当公开的信息，或者故意泄露服务对象身份识别信息和个人隐私」予以监督管理和处罚。",
          icon: "icon authing-icon authing-weisheng icon-style",
        },
        "item-two": {
          title: "就医体验差",
          content:
            "市民在医疗系统中，都有分别的账号。这不仅意味患者需要在多家医疗机构中，反复用不同的账号密码登录，更意味着个人的过敏史、医保记录等等都保存在不同的系统中，造成个人数据被系统割裂。",
          icon: "icon authing-icon authing-duochongshenfen icon-style",
        },
        "item-three": {
          title: "从医体验差",
          content:
            "医疗单位的人员访问医疗系统也是困难重重，他们需要在每个系统中记住不同的密码，例如挂号系统、收费系统、住院系统、药房系统、医疗设备系统等等。不仅如此，随着系统不断变多、医疗人员不断变动，管理所有的人员身份也是一项艰巨的任务，每次变动都意味着需要逐个系统一次又一次地增、删、改、查。",
          icon: "icon authing-icon authing-butongxitong icon-style",
        },
        "item-four": {
          title: "医疗系统的扩展性和安全性",
          content:
            "每当医疗系统需要和新的合作单位集成医疗服务时，都需要二次开发新的接口，以此勉强提升扩展能力，并且拓展的服务接口难以符合身份安全的标准。",
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
      },
      values: {
        "item-one": {
          title: "保护数据隐私，增强患者信任",
          content:
            "在处理个人信息时，Authing 采取数据加密、统一管理，保证患者的数据安全和数据主权，使任何医疗系统都能快速符合《医疗卫生服务单位信息公开管理办法（试行）》，保护患者的数据隐私，增强患者对医疗服务的信任。",
          icon: "icon authing-icon authing-shujuyinsi icon-default",
        },
        "item-two": {
          title: "人人都喜爱的数字就医体验",
          content:
            "患者无需记住密码、或仅需记住一个密码，就可以登录每个医疗系统，使患者再也无需因为忘记密码而耽搁病情。并且，医疗机构无需开发或运维，就可以为患者一键开启面部、指纹登录，或支付宝、微信登录任何医疗系统。",
          icon: "icon authing-icon authing-yiyuan icon-default",
        },
        "item-three": {
          title: "统一医疗系统，为从医人员减压",
          content:
            "Authing 统一医疗系统中的所有人员和软件。无论员工存储在哪儿，无论软件是由谁开发的（哪怕是很旧的软件），Authing 都能轻松连接任何用户和应用。Authing 优化了从医人员的数字体验。",
          icon: "icon authing-icon authing-tongyixitong icon-default",
        },
        "item-four": {
          title: "从医疗系统出发，拓展以人为中心的智慧城市",
          content:
            "Authing 可以将不同医院、医疗系统中的患者整合在一起，创建统一身份的体验，在不同的卫生系统中统一管理所有人。患者可以用一个账号访问他的健康记录，用一张卡化验结果等等。这样的医疗体验会是城市现代化、数字化的切入点。使用 Authing，使城市从医疗系统出发，将优质的登录体验、高效的市民治理集成到任何城市服务当中，搭建以人为中心的智慧城市。",
          icon: "icon authing-icon authing-zhihuichengshi icon-default",
        },
      },
      support: {
        title: "Authing 如何支持医疗行业",
      },
    },
    game: {
      title: "游戏解决方案",
      sub: "让玩家快进来，让黑客远离点，做安全的爆款游戏。",
      challenges: {
        "item-one": {
          title: "安全性与用户体验无法兼顾",
          content:
            "简洁的登录设计、轻松的认证流程，不意味着牺牲用户体验，更不留安全隐患。",
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
        "item-two": {
          title: "权限控制困难",
          content:
            "多人游戏中存在各种格式的分组，权限控制变得尤为困难，权限问题让每家游戏公司都很头疼。",
          icon: "icon authing-icon authing-management icon-style",
        },
        "item-three": {
          title: "付费意愿越高，游戏欺诈越多",
          content:
            "随着游戏行业的不断发展，人们的电子游戏时间变得越来越长，付费意愿越来越高。与此同时，游戏内的欺诈行为愈发严重，用户的财产利益易被侵犯。",
          icon: "icon authing-icon authing-Consume icon-style",
        },
        "item-four": {
          title: "用户系统开发周期长，影响游戏上线",
          content:
            "用户系统、身份认证并不是开发的核心，但却又是一个非常重要的环节。冗长的用户系统开发时间，会大幅推迟游戏的上线时间。",
          icon: "icon authing-icon authing-zhouqi icon-style",
        },
      },
      values: {
        "item-one": {
          title: "保证安全，玩得开心",
          content:
            "Authing 不会让公司或开发者在安全性和用户体验之间做选择。你可以配置两步认证的策略，并选择对适合你的用户的身份验证方式。",
          icon: "icon authing-icon authing-Safety icon-default",
        },
        "item-two": {
          title: "身份认证，由繁变简",
          content:
            "Authing 可以在任何的异构环境中轻松实现，无论是什么语言或是技术栈。Authing 提供了 10+ 种主流语言的软件开发工具包（SDK）和应用接口（API），并方便你在公有云或混合云中快速部署 Authing。",
          icon: "icon authing-icon authing-caozuo icon-default",
        },
        "item-three": {
          title: "权限管理，灵活强大",
          content:
            "基于 RBAC、ABAC 的权限控制，更显灵活强大，每个用户的权限通过你创建的角色进行控制。",
          icon: "icon authing-icon authing-management icon-default",
        },
        "item-four": {
          title: "快速部署，加速游戏上线",
          content:
            "快速部署身份环节，加快游戏上线，与认证相关的开发工时减少 51% ，将运营管理时间减少 200 个小时。",
          icon: "icon authing-icon authing-Smooth icon-default",
        },
      },
      support: {
        title: "Authing 如何支持游戏行业",
      },
    },
    software: {
      title: "科技解决方案",
      sub: "一次认证多点互联，一个软件全局监测。",
      challenges: {
        "item-one": {
          title: "开发效率低，成本浪费严重",
          content:
            "产品研发非常缓慢，我们每开发一个应用，就要进行一次用户系统的开发，并且实施复杂，面对不同的场景需要的能力也不尽相同，在时间成本和人力成本都是高度的浪费。",
          icon: "icon authing-icon authing-highcost icon-style",
        },
        "item-two": {
          title: "安全性面对巨大挑战",
          content:
            "安全风险的增加，身份认证用户管理方面的错误往往都是致命的，并且目前有安全，认证专业的人才，并且能精通各种认证协议是少之又少，贵之又贵的。",
          icon: "icon authing-icon authing-Safety icon-style",
        },
        "item-three": {
          title: "错失增长机会",
          content:
            "在应用矩阵中，会开发不同的平台，导致咱们的用户会散落在不同的登录方式的平台中，甚至需要在自己的不同产品的进行互相引流，导致增长机会的错失。",
          icon: "icon authing-icon authing-jihui icon-style",
        },
        "item-four": {
          title: "昂贵的维护成本",
          content:
            "云技术，人工智能，大数据，身份等多项技术持续更新，内部系统更新速度想要与行业内持平需要昂贵的维护成本和持续的开发创新能力，以及更多的时间成本，人力成本的投入。",
          icon: "icon authing-icon authing-low-cost icon-style",
        },
      },
      values: {
        "item-one": {
          title: "加快产品落地，降低开发成本",
          content:
            "Authing 加速产品研发，加快业务上线，与认证相关的开发工时减少 51% ，将运营管理时间减少 200 小时，让产品快速落地，实现业务价值。",
          icon: "icon authing-icon authing-low-cost icon-default",
        },
        "item-two": {
          title: "消除身份风险，安全值得信赖",
          content:
            "对冲安全风险，专业的事情要交给专业的人来做，将身份环节交给专业的人来做，以此来对冲安全风险。动态令牌、人脸识别等多因素认证（MFA）功能，让你即刻拥有，开箱即用，值得信赖。",
          icon: "icon authing-icon authing-Safety icon-default",
        },
        "item-three": {
          title: "增加企业收入，软件产生价值",
          content:
            "促进业务增长，集中管理所有来源的用户，增加用户的体验，以此来创造交叉销售机会，促使增加企业收入，实现客户成功。",
          icon: "icon authing-icon authing-value icon-default",
        },
        "item-four": {
          title: "持续创新迭代，身份开箱即用",
          content:
            "提供跨平台、10+ 语言的软件开发工具包（SDK）和应用接口（API），可以快速安全地将用户验证集成到各种应用中。有专业的团队进行产品的版本迭代以及创新性技术更新，快速的同步给所有用户。",
          icon: "icon authing-icon authing-chuangxin icon-default",
        },
      },
      support: {
        title: "Authing 如何支持科技行业",
      },
    },
    government: {
      title: "政府解决方案",
      sub: "让公民用一个账号访问所有系统，安全登录政务服务。",
      challenges: {
        "item-one": {
          title: "数据孤立，安全性分散",
          content:
            "身份数据散落在不同的平台中，各个部门都会有自己部门的系统和流程。在政务工作中，不同的系统和流程会让工作的协调组织性下降，工作效率与协同性大打折扣。",
          icon: "icon authing-icon authing-shujufensan icon-style",
        },
        "item-two": {
          title: "维护成本高，功能受限",
          content:
            "云技术，人工智能，大数据，身份等多项技术持续更新，政务内部系统的同步更新需要昂贵的维护成本和持续的开发创新能力，同时会有诸多功能因为技术的原因而受到限制。",
          icon: "icon authing-icon authing-highcost icon-style",
        },
        "item-three": {
          title: "部署环境错综复杂",
          content:
            "不同的软件部署在不同的云环境下，会面临多云，混合云等错综复杂的管理情况，会使管理工作变得极为困难。",
          icon: "icon authing-icon authing-deploy icon-style",
        },
        "item-four": {
          title: "市民体验需要不断提升",
          content:
            "为人民服务是各级政府的首要任务，在政府数字化改革的同时，市民的用户体验也成为重要的挑战，需要为市民提供更加灵活的数字化服务，在线快速的办理服务。同时要考虑到不同年龄，不同属性，不同业务的市民需求，让数字化政务服务到每一位市民的优质生活。",
          icon: "icon authing-icon authing-userexperience icon-style",
        },
      },
      values: {
        "item-one": {
          title: "快速部署，顺滑无感",
          content:
            "Authing 平台到手即用，并自动安装及更新。基于 Authing 新建政务软件，或将旧软件连接至 Authing，都只需数小时，无需重复编程，并且提供 10+ 语言的软件开发工具包（SDK）和应用接口（API）。",
          icon: "icon authing-icon authing-Smooth icon-default",
        },
        "item-two": {
          title: "多重安全，值得信赖",
          content:
            "对数据安全监管技术进行大量研究后，Authing 提升了针对违法跨境数据流动等安全隐患的监测发现与处理能力，采用全局 MFA 提升整体的安全性。一方面时刻监测登录环境，使所有的政务应用都变得更加安全；另一方面，增加用户的可用性，即使忘记密码，也可以使用指纹、短信、动态密码，人脸识别等作为验证因素。",
          icon: "icon authing-icon authing-Safety icon-default",
        },
        "item-three": {
          title: "一个软件，全局监测",
          content:
            "集中管控用户访问政务服务的行为信息、画像信息。通过大数据技术，实现跨领域、跨渠道的综合分析，挖掘人民群众的政务需求，提高政务服务的质量和效率。",
          icon: "icon authing-icon authing-monitor icon-default",
        },
        "item-four": {
          title: "一次采集，办事畅行",
          content:
            "用户集中管理个人资料、授权填写表格，实现群众办事“一号”畅行，避免重复向部门、机构提交个人信息、办事材料等，实现用户基础信息的多元采集、互通共享、多方利用。",
          icon: "icon authing-icon authing-acquisitionModality icon-default",
        },
      },
      support: {
        title: "Authing 如何支持政府",
      },
    },
    finance: {
      title: "金融解决方案",
      sub: "帮助各种规模的金融服务公司加快创新速度并提升用户体验。",
      challenges: {
        "item-one": {
          title: "不容忽视的用户体验",
          content:
            "眼光敏锐的消费者对于用户体验的标准越来越高。无论是他们在登录到用户系统，还是在购买金融产品时，用户体验是一切优质服务的基础。",
          icon: "icon authing-icon authing-tiyan icon-style",
        },
        "item-two": {
          title: "部门间协同受阻，权限管理困难",
          content:
            "大多数金融机构都有许多业务部门，每个部门都有自己的系统和服务。这通常导致部门间的沟通和协同性效率降低，从而影响公司的业务效率。多部门，多组织需要分别管理，不同组织的权限管理成为极大挑战。",
          icon: "icon authing-icon authing-hinder icon-style",
        },
        "item-three": {
          title: "开发难度大，安全性面临巨大挑战",
          content:
            "在金融服务行业场景下，用户系统，身份认证环节情况复杂，开发难度大幅度上升，并且会涉及到大量敏感场景，在安全环节会受到大量的挑战，身份环节更是重中之重，任何的错误往往都是致命的。",
          icon: "icon authing-icon authing-kaifa icon-style",
        },
        "item-four": {
          title: "从业人员涉及系统众多，管理难度大",
          content:
            "每位金融行业的工作人员需要涉及十几种甚至几十种软件工具，每当有员工入职离职时，都要面临账号管理的问题，无论是办理时间，还是信息安全，都急需改善。",
          icon: "icon authing-icon authing-xitong-2 icon-style",
        },
      },
      values: {
        "item-one": {
          title: "无法忘记的客户体验",
          content:
            "眼光敏锐的消费者对于用户体验都具有很高的标准，无论他们是登录查看银行业务还是购买心仪保险。用户体验已成为当今许多数字化转型的基石，而这一切都始于身份。启用单一登录，提供真正的全渠道体验。",
          icon: "icon authing-icon authing-tiyan icon-default",
        },
        "item-two": {
          title: "助力完成数字化转型",
          content:
            "一劳永逸地设置身份，以加快创新进度。Authing 旨在将任何员工，供应商，合作伙伴以及用户跟任何应用连接在一起，保证安全性的同时提高易用性，并且可以轻松地与你已有的系统进行集成。",
          icon: "icon authing-icon authing-zhuanxingjia icon-default",
        },
        "item-three": {
          title: "多种身份源，点击即用",
          content:
            "快速集成社会化登录方式，多身份源。常见的第三方登录方式例如：微信，钉钉，微博等。在 Authing 只需要点击一下，就可以进行使用。",
          icon: "icon authing-icon authing-duozhong icon-default",
        },
        "item-four": {
          title: "值得信赖的企业级安全性",
          content:
            "动态令牌，人脸识别等多因素认证（MFA）功能，让你即刻拥有，开箱即用，全面提高系统访问安全，保障用户交易安全，改善用户体验。",
          icon: "icon authing-icon authing-Safety icon-default",
        },
      },
      support: {
        title: "Authing 如何支持金融行业",
      },
    },
    publisher: {
      title: "出版解决方案",
      sub: "让读者专注阅读，数亿用户在弹指间伸缩，发行、作者、编辑，尽在掌控。",
      challenges: {
        "item-one": {
          title: "错失增长机会",
          content:
            "在应用矩阵中，会开发不同的平台，用户需要多个账号登录多个不同平台，导致咱们的用户会散落在各个平台中，甚至需要在自己的不同产品的进行互相引流，导致增长机会的错失。",
          icon: "icon authing-icon authing-opportunity-growth icon-style",
        },
        "item-two": {
          title: "开发效率低，成本浪费严重",
          content:
            "产品研发非常缓慢，我们每开发一个应用，就要进行一次用户系统的开发，并且实施复杂，面对不同的场景需要的能力也不尽相同，在时间成本和人力成本都是高度的浪费。",
          icon: "icon authing-icon authing-highcost icon-style",
        },
        "item-three": {
          title: "权限管理冗杂",
          content:
            "有大量编辑需要在线编辑各个品类的图书，需要复杂的权限控制和审批流程。",
          icon: "icon authing-icon authing-tushuguanli icon-style",
        },
        "item-four": {
          title: "安全性面对巨大挑战",
          content:
            "许多用户需要在线上进行图书购买，在线阅读。安全性将会面临巨大的挑战，身份将会是第一道防线，身份认证用户管理方面的错误往往都是致命的。",
          icon: "icon authing-icon authing-Safety icon-style",
        },
      },
      values: {
        "item-one": {
          title: "给读者真正的极致体验",
          content:
            "阅读书籍是一个补充营养的过程，在补充营养的过程中学生反复输入密码是一个痛苦的过程，单点登录帮助学生专注于阅读而不是账号密码，仅登录一次，享受全部服务。",
          icon: "icon authing-icon authing-Smooth icon-default",
        },
        "item-two": {
          title: "让安全值得信赖",
          content:
            "当学生在出版社购买图书时，这些帐户也将成为吸引不法分子的蛋糕。动态密码和人脸识别等多因素认证相对单密码认证，是一次更好的安全升级。",
          icon: "icon authing-icon authing-Safety icon-default",
        },
        "item-three": {
          title: "数亿用户，弹指间伸缩",
          content:
            "当峰值来临时，登录接口挂掉，新用户无法注册，这会对你的业务造成致命的打击。而 Authing 会在峰值时自动伸缩，促成业务成功。",
          icon: "icon authing-icon authing-user icon-default",
        },
        "item-four": {
          title: "发行、作者、编辑，权限尽在掌控",
          content:
            "出版社涉及到的角色很多，选题委员会、编辑、发型、作者等，每一个角色都有不同的权限和分组，Authing 提供的 RBAC 权限控制方案可以方便的掌控所有角色。",
          icon: "icon authing-icon authing-multiple-roles icon-default",
        },
      },
      support: {
        title: "Authing 如何支持出版行业",
      },
    },
    education: {
      title: "教育解决方案",
      sub: "安全无缝的学生体验，保护学生和教职工，WiFi、校园卡、一网通行。",
      challenges: {
        "item-one": {
          title: "频繁面临考验的校园信息安全",
          content:
            "学校经常遭受网络攻击，学生学籍信息隐私性极具加强，层出不穷的学生信息泄露新闻，信息泄露的学生与家长被推销电话，垃圾短信频繁轰炸。",
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
        "item-two": {
          title: "老旧软件消耗巨大成本",
          content:
            "学校的老软件依旧消耗着维护成本，学校 IT 急需现代化。在面临查成绩，线上大型直播会议时，往往会面临服务器宕机，学生家长登录失败等峰值的波动，导致体验感大幅度下降。",
          icon: "icon authing-icon authing-Consume icon-style",
        },
        "item-three": {
          title: "权限管理需求迫在眉睫",
          content:
            "教育场景的用户角色周期长，批量变动大，面临着周期间的权限管控的挑战，不同角色会面临多个身份验证的场景。",
          icon: "icon authing-icon authing-management icon-style",
        },
        "item-four": {
          title: "数字化转型困难",
          content:
            "难以拥有完善的跨平台、各语言、多功能的 SDK 和 API，有的甚至无法自身成为统一身份源，不具备任何的业务和技术拓展性，阻碍学校在未来实施、部署新的技术和应用，使学校丧失了数字化的前瞻性和竞争力。学校对登录流程和品牌 UI 等定制化的需求，大部分统一身份管理平台仍然依赖耗费巨大人力去做二次定制化开发，无法快速实现 UI 配置化。",
          icon: "icon authing-icon authing-zhuanxingjia icon-style",
        },
      },
      values: {
        "item-one": {
          title: "集成所有教育资源，让知识触手可及",
          content:
            "图书馆、科技馆、博物馆等无数数字化知识存放在各自的系统中，与每个学生存在着距离。Authing 要打通所有数字化教育资源与学生之间的距离。让学生通过一个账号，通过一个屏幕可以获取到任何，他需要的知识。",
          icon: "icon authing-icon authing-jiaoyuziyuan icon-default",
        },
        "item-two": {
          title: "7*24，守护学生信息安全",
          content:
            "学校各个职能部门包含了大量敏感数据，安全运行至关重要。Authing 构建全方位、多层次、完善的身份安全保障体系，在保证网络安全的基础上，更可以保证数据安全。根据基础架构及各个应用系统的设计要求，采取不同的安全策略与安全措施，保证系统安全。Authing 通过身份认证、角色定义与权限分配，确保每个用户能且只能访问相应的信息资源与应用服务。真正的做到，7 天 * 24 小时，可用，可查，可追踪的用户管理平台，实打实地守护学生信息安全。",
          icon: "icon authing-icon authing-xinxianquan icon-default",
        },
        "item-three": {
          title: "操作便捷，无需维护",
          content:
            "优秀的老师是每个学校最宝贵的财富。他们的热情，动力和热情能够激发和吸引学生，并最终使他们取得最大的成就。Authing 使用户管理系统，结构清晰、界面友好、操作简单、无需维护。让每一位老师将所有的精力放在学生身上，不再被维护系统所困扰。",
          icon: "icon authing-icon authing-caozuo icon-default",
        },
        "item-four": {
          title: "一切都随心设定，不只是 UI、域名",
          content:
            "Authing 用户登录组件帮助研发人员避免了很多底层认证的实现细节，同时也包括繁琐的 UI 开发。它是一种可嵌入的登录表单，可根据不同学校的需求进行个性化配置。 提供跨平台、10+ 语言的软件开发工具包（SDK）和应用接口（API），可以快速安全地将用户验证集成到各种应用中。",
          icon: "icon authing-icon authing-sheding icon-default",
        },
      },
      support: {
        title: "Authing 如何支持教育行业",
      },
    },
    consume: {
      title: "新消费解决方案",
      sub: "推动线上线下一体化进程，助力商家开启消费新时代。",
      challenges: {
        "item-one": {
          title: "业务快速发展，内部应用激增",
          content:
            "内部应用激增，员工需要记忆很多账号密码，访问不同系统，需多次认证，员工体验不佳。",
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
        "item-two": {
          title: "人员急速扩张，角色管理复杂",
          content:
            "涉及正式员工、临时工、外包商、经销商、供应链活动等多种⻆色，人员入离职账号增删管理复杂。",
          icon: "icon authing-icon authing-Consume icon-style",
        },
        "item-three": {
          title: "权限管理冗杂且不清晰",
          content:
            "⻔店、分支机构、灵活用工权限管理乱，没有权限统一入口，申请权限难、溯源难、监管难。",
          icon: "icon authing-icon authing-management icon-style",
        },
        "item-four": {
          title: "数据大量沉淀，形成难以互通的孤岛",
          content:
            "由于员工账号与数据的割裂，难以实现数据互通和统一分析，数据在管理决策层的应用较弱。",
          icon: "icon authing-icon authing-zhuanxingjia icon-style",
        },
      },
      values: {
        "item-one": {
          title: "消费者统一身份管理，提升登录体验",
          content:
            "打通微信、微博、支付宝等第三方登录，完善消费者会员体系身份管理的同时利用丰富的社会化登录，实现用户数据采集，提升消费者登录体验。",
          icon: "icon authing-icon authing-jiaoyuziyuan icon-default",
        },
        "item-two": {
          title: "整合用户资源，精准定位消费者画像",
          content:
            "整合管理整个供应链体系的用户资源，多端多设备多社交登录，打通会员体系管理，精准定位消费者身份画像，构建智能营销和品牌粘度。",
          icon: "icon authing-icon authing-xinxianquan icon-default",
        },
        "item-three": {
          title: "数亿用户，弹指间伸缩",
          content:
            "当峰值来临时，登录接口挂掉，新用户无法注册，这会对你的业务造成致命的打击。而 Authing 会在峰值时自动伸缩，促成业务成功。",
          icon: "icon authing-icon authing-caozuo icon-default",
        },
        "item-four": {
          title: "企业运维尽在掌控",
          content:
            "当员工加入公司或晋升时，可以轻松在后台实现分配和更改不同应用的权限，企业也可以在员工离职时，轻松取消、撤销所有不同平台的访问权限，保护企业数据安全，节省运维人员80%的工作量。",
          icon: "icon authing-icon authing-sheding icon-default",
        },
      },
      support: {
        title: "Authing 如何支持新消费行业",
      },
    },
    enterprise: {
      title: "企业服务解决方案",
      sub:
        "使用 Authing 提高客户采用率、满足合规性需求、保护您的 API 并让您的企业面向未来。",
      challenges: {
        "item-one": {
          title: "企业内部协同陷入瓶颈",
          content:
            "有限的研发资源聚焦在自身产品开发上，企业内部信息化投入不足，重视度不够，企业内部协同效率较低。",
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
        "item-two": {
          title: "人员流动性大和急速扩张",
          content:
            "涉及正式员工、灵活用工、上下游合作伙伴等多种⻆色，人员入离职账号增删管理复杂，数据安全和审计不合规，上下游合作伙伴间的身份登录信息不互通，注册登录麻烦。",
          icon: "icon authing-icon authing-Consume icon-style",
        },
        "item-three": {
          title: "应用数量激增，没有统一管理",
          content:
            "业务发展快，应用工具激增，各应用之间数据和身份互相割裂，没有形成统一的登录、授权、管理平台，IT运维人员效能低，压力大。",
          icon: "icon authing-icon authing-management icon-style",
        },
        "item-four": {
          title: "数字化运营能力较弱",
          content:
            "企业服务行业对用户营销场景的管理薄弱，在广告投放的用户身份管理、注册用户信息、统一登录入口的设计上难以适应灵活多变的业务场景。",
          icon: "icon authing-icon authing-zhuanxingjia icon-style",
        },
      },
      values: {
        "item-one": {
          title: "增加企业收入",
          content:
            "为潜在客户提供优质产品并通过快速实施加快销售周期，从而节省宝贵的工程开发时间。",
          icon: "icon authing-icon authing-jiaoyuziyuan icon-default",
        },
        "item-two": {
          title: "联合单点登录",
          content:
            "默认情况下提供联合 SSO 身份验证，让您的用户在登录一次并访问所有应用程序时获得无缝体验。",
          icon: "icon authing-icon authing-xinxianquan icon-default",
        },
        "item-three": {
          title: "安全和管理",
          content:
            "在零信任环境中提高 API 安全性并确保内部和外部合作伙伴用例的合规性。 Authing 基于开放标准的方法提供端到端的 API 安全和管理。",
          icon: "icon authing-icon authing-caozuo icon-default",
        },
        "item-four": {
          title: "防范不良行为",
          content:
            "不良行为者不断试图入侵企业，并将用户凭据与额外的安全层相结合，使得破坏安全性的难度呈指数级增长。 Authing 采用自适应 MFA，有效的防范这些不良行为。",
          icon: "icon authing-icon authing-sheding icon-default",
        },
      },
      support: {
        title: "Authing 如何支持 SaaS 行业",
        api: {
          title: "API 安全",
          subtitle:
            "在零信任环境中提高 API 安全性并确保内部和外部合作伙伴用例的合规性可能非常具有挑战性。Authing 基于开放标准的方法提供端到端的 API 安全和管理。",
          item1: {
            title: "对于用户",
            descript:
              "通过支持所有 OAuth 2.0 授权流以及细粒度的范围和权限，轻松保护和公开您的 API，从而扩大市场范围并提供更好的用户体验。",
          },
          item2: {
            title: "对于应用和系统",
            descript:
              "只需轻按一下开关，即可轻松促进 API 与非交互式外部客户端以及内部 API 之间的安全通信。",
          },
          item3: {
            title: "对于企业开发者",
            descript:
              "使第三方应用服务器、API 和系统后端能够向您的 API 发出经过身份验证的请求，同时始终保持对精细范围和权限的控制。",
          },
        },
        security: {
          title: "众多合规认证，保障身份安全",
          descript1:
            "毋庸置疑，客户数据安全性和合规性是大多数公司的首要考虑因素。Authing 在产品中内置了先进的安全性，因此您无需为您的用户和业务安全忧虑。",
          "descript2-title": "行业标准协议：",
          descript2:
            "通过采用支持 OAuth 和 OpenID Connect 等行业认证标准的身份平台，提高业务运营和执行的一致性和连续性。",
          "descript3-title": "合规性和认证：",
          descript3:
            "Authing 拥有多项国内国际合规认证，包括国家三级等保、SOC 2、GDPR、ISO 9001、CCPA、PCI、HIPAA 和 FERPA 等，誓要保障每一位用户、每一个业务的安全。",
          "descript4-title": "公共和私有云：",
          descript4:
            "在 Authing 的公共云、我们的私有云或您的 AWS 环境中托管您的应用。我们高度可用的多租户云服务每天可以处理大量交易。",
        },
        mfa: {
          title: "自适应多因素认证",
          subtitle:
            "自适应多因素认证 MFA 是一种简单有效的安全实践方法，它能够在用户名和密码之外再额外增加一层安全保护，在不牺牲用户体验的情况下进行安全身份验证。",
          item1: {
            title: "保护用户免受凭证盗窃和欺诈",
            descript1:
              "多因素认证是防止账户被盗取有效的方法之一。攻击者如果想要入侵受 MFA 保护的帐户，不仅需要盗取凭证，还需要验证额外附加的因素。",
            descript2:
              "通常，我们看到在处理敏感数据的行业倾向于使用 MFA。这些垂直领域没有额外的身份层，所以对 MFA 的需求迫切。",
          },
        },
        sso: {
          title: "单点登录 SSO",
          subtitle:
            "单点登录 SSO 是整合企业系统的解决方案之一，旨在多个应用系统中，用户只需要登录一次就可以访问所有相互信任的应用系统。",
          item1: {
            title: "一次登录，轻松访问所有应用",
            descript1:
              "Authing 凭借单点登录技术，实现成员、客户在一处访问任何软件服务，并统一管控身份权限。无论通过企业联合、 社会登录还是用户名和密码身份验证，用户只需登录一次，就可以使用他们被授予访问权限的所有应用。",
            descript2:
              "Authing 支持 OAuth2、OIDC、SAML、LDAP 等多种协议，开发者可以配合统一用户池，最低五行代码轻松实现单点登录，实现登录定制化。",
          },
        },
      },
    },
  },

  // wechat: {
  //   banner: {
  //     title: "微信生态解决方案",
  //     subtitle:
  //       "Authing 快速实现任何 Web、App 和企业软件的身份认证和用户管理，为你的顾客和员工提供最完善的登录解决方案。",
  //   },
  //   "mini-login-scan": {
  //     title: "扫描小登录二维码登录",
  //     content:
  //       "这是 Authing 的一个开创性的设计，在 Authing 中开启扫描小登录二维码登录后可以获得微信官方的实名用户信息， 用户一键授权即可以真实号码完成注册或者登录，为开发者建立以手机号码为基础的账号体系。",
  //   },
  //   "pc-scan-login": {
  //     title: "PC 扫描登录",
  //     content:
  //       "微信 PC 扫码登录可以让用户使用微信身份安全登录第三方应用或网站，在 Authing 中开启微信扫码登录之后，可实现通过 Authing 快速获取微信用户基本开放信息和帮助用户实现基础开放功能。",
  //   },
  //   "web-authorize": {
  //     title: "微信网页授权",
  //     content:
  //       "Authing 通过 SDK 为开发者提供了一种快速在微信网页中获取用户信息并完成登录的方法。如果用户在微信客户端中访问第三方网页、公众号可以通过微信网页授权机制，来获取用户基本信息，进而实现业务逻辑。",
  //   },
  //   "mini-program-login": {
  //     title: "微信小程序内登录",
  //     content:
  //       "Authing 通过 SDK 为开发者提供了一种快速在小程序中获取用户信息并完成登录的方法。通过 Authing 的 SDK 可以方便地获取微信提供的用户身份标识，快速建立以手机号码为基础的账号体系。",
  //   },
  //   "mobile-login": {
  //     title: "移动端拉起微信登录",
  //     content:
  //       "Authing 为开发者提供了一种在移动端（iOS or 安卓）应用中快速跳转微信登录获取用户信息的方式，通过简单的调用 Authing 移动端 SDK 可以完成微信账号接入。",
  //   },
  //   "mobile-mini-program-login": {
  //     title: "移动端拉起小程序登录",
  //     content:
  //       "移动端拉起小程序登录是建立移动端以手机号为中心用户体系的关键方式，Authing 通过 SDK 为开发者大大降低了开发的复杂度，一行代码即可通过移动端获取用户在小程序中授权的手机号，建立以手机号码为基础的账号体系。",
  //   },
  // },
  scene: {
    "title-intro": "场景简介",
    "title-value": "Authing 的价值",
    "title-support": "Authing 如何支持各种场景",
  },
  wechat: {
    banner: {
      title: "微信生态解决方案",
      subtitle:
        "Authing 快速实现任何 Web、App 和企业软件的身份认证和用户管理，为你的顾客和员工提供最完善的登录解决方案。",
    },
    intro:
      "当你基于微信生态开始开发一个激动人心的应用时，如何利用好微信多场景的开放能力、如何处理复杂的 OpenID、UnionID 机制将会是你需要去考虑的问题。微信生态非常庞大，登录场景就有好几个（如 PC 网站扫码、公众号网页授权、小程序内授权等等），其需要调用完全不同的接口，对于开发者而言，无疑加大了理解和开发成本。",
    value:
      "Authing 针对微信生态的复杂场景，在前端为开发者提供了简洁、统一的 SDK，在后端基于 OpenID、UnionID、手机号三个维度自动处理同一身份识别、账号合并等逻辑。开发者只需要调用前端 SDK，而无需操心各种复杂的身份识别逻辑。",
    type: {
      item1: {
        title: "PC 网站使用微信扫码登录",
        descript:
          "微信 PC 扫码登录可以让用户使用微信身份安全登录第三方应用或网站，在 Authing 中开启微信扫码登录之后，可实现通过 Authing 快速获取微信用户基本开放信息和帮助用户实现基础开放功能。",
      },
      item2: {
        title: "PC 网站使用小程序扫码登录",
        descript:
          "这是 Authing 的一个开创性的设计，在 Authing 中开启扫描小登录二维码登录后可以获得微信官方的实名用户信息， 用户一键授权即可以真实号码完成注册或者登录，为开发者建立以手机号码为基础的账号体系。",
      },
      item3: {
        title: "移动端拉起微信登录",
        descript:
          "Authing 为开发者提供了一种在移动端（iOS or 安卓）应用中快速跳转微信登录获取用户信息的方式，通过简单的调用 Authing 移动端 SDK 可以完成微信账号接入。",
      },
      item4: {
        title: "移动端拉起小程序登录",
        descript:
          "移动端拉起小程序登录是建立移动端以手机号为中心用户体系的关键方式，Authing 通过 SDK 为开发者大大降低了开发的复杂度，一行代码即可通过移动端获取用户在小程序中授权的手机号，建立以手机号码为基础的账号体系。",
      },
      item5: {
        title: "微信内网页使用微信授权登录",
        descript:
          "Authing 通过 SDK 为开发者提供了一种快速在微信网页中获取用户信息并完成登录的方法。如果用户在微信客户端中访问第三方网页、公众号可以通过微信网页授权机制，来获取用户基本信息，进而实现业务逻辑。",
      },
      item6: {
        title: "微信小程序内登录",
        descript:
          "Authing 通过 SDK 为开发者提供了一种快速在小程序中获取用户信息并完成登录的方法。通过 Authing 的 SDK 可以方便地获取微信提供的用户身份标识，快速建立以手机号码为基础的账号体系。",
      },
    },
  },
  idaas: {
    banner: {
      title: "身份云 IDaaS 已替代传统 IAM",
      subtitle:
        "随着企业数字转型和上云进度的加速，企业信息安全的维度和边界正在变得越来越复杂，身份认证和访问权限管理作为第一道门承载着极为关键的使命。",
    },
    intro:
      "传统 IAM 在内部员工管理和外部用户管理等场景中力不从心；上线新应用和兼容老应用时不够灵活。与此同时，横空出世的 IDaaS 服务由于兼具云的扩展性优势和跨环境的身份识别及权限管理能力，取代了传统的 IAM 成为企业基础设施。",
    value:
      "IDaaS 是 Identity as a Service 的缩写， 包含传统 IAM 的全部功能，并能为企业带来更多收益：提升营销和运营效率；加速新业务上线；提升安全性降低网络攻击风险；提升用户体验。",
    type: {
      item1: {
        title: "运营能力提升",
        descript:
          "传统 IAM 账号中心的运营能力较弱，难以满足大型组织在业务方面的需求，而 IDaaS 的多租户运营平台和自动化工作流（Workflow）则可以便捷地提升企业运营效率。",
      },
      item2: {
        title: "伸缩性和扩展性提升",
        descript:
          "当你的用户量不断上升时，用户系统承载的压力也会不断增加，云原生架构的 IDaaS 则可以很好的解决这一问题，以 Authing 身份云 IDaaS 为例，每月有近千万用户通过 Authing 登录进入数千个系统中，有了大规模数据的处理经验，构建起的数字身份解决方案能够更好的支持企业扩张。",
      },
      item3: {
        title: "安全性提升",
        descript:
          "数据资产正在逐渐超越实体资产成为企业最有价值的核心。而针对数据资产的盗窃和攻击也呈不断上升趋势。传统的 IAM 在本地构建，难以保障混合云环境下的企业安全，权限管理颗粒度较粗，访问控制策略单一。",
      },
    },
  },

  ad: {
    title: "AD 中国区替代解决方案",
    subtitle:
      "这就是为什么有远见的 IT 组织希望将其旧版 AD 环境与 Authing 中的现代 SSO 集成在一起。与 Authing  的集成提供了一个网关，可以轻松安全地将你的员工连接到他们想使用的任何服务和资源",
    navList: {
      agent: "Authing Active Directory 代理",
      function: "AD 代理集成功能",
      interval: "主动 / 长轮询",
      connection: "AD 代理连接",
      management: "AD 代理工作管理",
      integrate: "使用 Authing 计划 AD 集成",
      authentication: "用户认证作业",
      import: "用户导入作业",
      synchrony: "实时同步作业",
      install: "安装 AD 代理",
      mix: "融合和谐",
    },
    agent: {
      title: "Authing Active Directory 代理",
      overview1:
        "Active Directory（AD）自 1999 年 Microsoft 首次随 Windows 2000 Server 一起发布时就出现了。多年来，它已成为管理基于身份的相关活动的关键本地服务。但是随着对云服务和应用程序需求的增长，组织已经开始意识到 AD 并不是为以云为中心的世界和当今的用例而构建的。尽管如此，他们仍希望有一种方法来利用其在 AD 方面的投资，并利用现代单一登录（SSO）的优势，通过单个界面访问其所有云以及本地应用程序和资源，同时减少管理开销。",
      overview2:
        "这就是为什么有远见的 IT 组织希望将其旧版 AD 环境与 Authing 中的现代 SSO 集成在一起。与 Authing 的集成提供了一个网关，可以轻松安全地将你的员工连接到他们想使用的任何服务和资源。为了帮助你计划和实施该集成，本文为你提供了从 AD 到 Authing 集成的功能和运营方面的见解。",
      text1:
        "Authing AD 代理是 AD 与 Authing 集成的核心。它提供 Authing 与本地 AD 实例之间的接口。Authing 和代理的设计本质上是可扩展的，因此可以轻松添加更多用户并根据需要部署更多代理。该代理使用安全的出站通信，通过长时间轮询提供负载平衡和作业管理，并使用长期的授权刷新令牌。",
      text2:
        "你将代理安装在 AD 域内的专用本地成员服务器上。在任何情况下，都不应将代理安装在域控制器上，因为如果你需要重新启动或重新安装代理，它将影响域控制器。",
    },
    function: {
      title: "AD 代理集成功能",
      overview1:
        "AD 代理提供两个主要功能。第一个是委托身份验证，该身份验证使你的本地 AD 实例可以继续作为身份验证源。通过委派身份验证，所有密码都保留在 AD 中，AD 决定用户是否可以访问 Authing 。",
      overview2:
        "每次用户尝试通过 Authing 访问资源时，Authing 会将那些身份验证尝试路由到本地 AD 目录。身份验证后，AD 允许 Authing 授予用户对 Authing 和分配的资源的访问权限。",
      text1:
        "代理的第二个主要功能是将具有相关属性的用户和组从 AD 导入 Authing 。导入过程在 Authing 中为你指定的 AD 组织单位（OU）中存在的每个用户对象创建一个新的用户对象。",
      text2:
        "Authing 然后将各自的 AD 和 Authing 用户链接在一起。这使 Authing 可以根据需要操纵和增强存储在其通用目录中的对象的用户属性，而不会影响存储在 AD 中的用户对象",
      text3:
        " 还可以将你的用户带到 Authing ，这使你可以利用 Authing 的功能集，例如为用户所需的任何资源提供集中式 SSO，无论这些资源驻留在本地还是在云中。",
    },
    internal: {
      title: "主动 / 长轮询",
      overview1:
        "Authing 在没有主代理或辅助代理的主动/主动配置中部署 AD 代理。因此，无需主动对代理进行负载均衡。所有已部署的代理始终处于活动状态，并使用长时间轮询来不断寻找新作业，因为它们处理这些作业的能力允许。",
      overview2:
        "因此，使用我们的长轮询模型，Authing 不再像传统的客户端服务器关系中那样等待代理发出的请求，而是继续将作业推送到作业池中，代理尽快获取它们。由于作业几乎立即被抢走，因此与传统模型相比，可以节省等待时间，并且可以更快地处理作业。",
      "img-text-interval": "主动 / 长轮询",
      "img-text-connection": "AD 代理连接",
    },
    connection: {
      title: "AD 代理连接",
      overview:
        "Authing AD 代理使用带有 TLS 服务器身份验证的证书固定来创建到 Authing 身份云的出站 HTTPS 连接。每个连接持续不超过 30 秒。在该连接时间内，AD 代理将侦听来自它可以处理的 Authing 服务的事件，例如 AD 身份验证事件。如果出现此类事件，则 AD 代理将抓住它进行处理并关闭连接。然后，AD 代理将立即打开新连接并再次侦听新作业。如果在连接的 30 秒窗口中没有事件发生，则代理将关闭连接并启动一个新的 30 秒连接以侦听另一个作业。",
    },
    management: {
      title: "AD 代理工作管理",
      overview1:
        "由于身份验证作业通常是需要快速处理的小型作业，而导入作业是需要花费更多时间的大型作业，因此 Authing 对每种作业类型使用不同的工作负载分配方法。Authing 可以更好地适应工作类型的固有差异。任何可用的代理都可以处理身份验证作业。因此，Authing 从可用代理池中为每个单独的身份验证工作随机选择一个代理。",
      overview2:
        "导入作业使用首选代理。虽然初始座席分配是随机的，但 Authing 将继续使用该座席执行后续任务，直到该座席变得不堪重负或不可用为止。届时，Authing 将分配其他代理来处理导入任务。",
      overview3:
        "默认情况下，Authing 用两个线程配置每个代理。但是，如果需要，你可以为代理配置最多 10 个线程，以解决代理需求。通常，代理中始终始终有一个线程可用于处理身份验证任务。例如，当代理获得发布导入作业时，Authing 不会在该作业完成之前将任何其他导入作业发送给该代理，但是该代理的第二个线程仍可用于接受身份验证作业。",
      block1: {
        title: "身份验证作业示例",
        item1: "作业线程保持打开状态 30 秒钟",
        item2: "代理执行 HTTP GET 从 Authing 获取作业",
        item3: "代理从 Authing 接收身份验证作业",
        item4: "代理执行身份验证作业",
      },
      block2: {
        title: "正在执行的导入作业示例",
        item1: "作业线程保持打开状态 30 秒钟",
        item2: "代理执行 HTTP GET 从 Authing 获取作业",
        item3: "代理从 Authing 接收导入作业",
        item4: "代理执行导入作业",
        item5: "代理成为导入作业的首选代理",
      },
    },
    integrate: {
      title: "使用 Authing 计划 AD 集成",
      overview:
        "在计划和建立集成时，重要的是要了解用户身份验证功能与用户导入之间的区别。例如，这些工作类型的频率及其用户群对你与 Authing 的 AD 集成的可操作性产生不同的影响。同样，了解用户群何时执行每种作业类型的重要性与了解用户群的规模同样重要，甚至更为重要。为了帮助你进行集成计划和构建工作，以下内容提供了每种作业类型的一些其他详细信息，包括每种作业类型的工作方式差异。",
    },
    authentication: {
      title: "用户认证作业",
      overview1:
        "当用户在 Authing 用户界面中输入其凭据进行身份验证时，Authing 会确定他们是否是 AD 主用户。如果他们是 AD 掌握用户，则 Authing 会将其身份验证请求添加到与该用户的目录实例关联的作业列表。将身份验证作业添加到作业列表后，Authing 会将作业随机分配给任何可用的 AD 代理轮询作业，然后分配的代理将在运行该代理的服务器上打开该作业。 AD 主用户是指其原始属性由 AD 实例拥有的用户。",
      overview2:
        "接下来，AD 代理使用 AD 集成设置中指定的用户名格式（例如用户主体名称（UPN））对用户进行查找。代理找到用户后，它将使用用户输入的凭据对 AD 实例执行 BIND。以下是代理可以用来查找用户的 UPN 查询的示例：",
      overview3:
        "与用户导入相比，用户身份验证作业可以快速执行。完成集成设置后，代理即可开始执行大量身份验证。根据需要，你可以在集成中部署多个其他代理，以分配更多资源进行身份验证。",
      overview4:
        "部署其他代理进行身份验证的原因之一可能是更好地处理季节性趋势的需求。例如，零售店在假期期间经常会经历较大的向上波动。对高可用性的需求是组织经常部署其他代理进行身份验证的另一个原因。",
      overview5:
        "此外，全球组织通常在靠近其不同地理位置的位置部署其他 AD 代理。在与域控制器或域控制器池非常接近的成员服务器上部署 AD 代理可以减少身份验证期间的延迟。如前所述，确保仅在专用成员服务器上而不在域控制器上部署 AD 代理很重要。",
    },
    import: {
      title: "用户导入作业",
      overview1:
        "用户导入可以通过计划导入或手动导入来启动。两种方法都在 Authing 中创建一个作业，并将该作业分配给首选代理。与身份验证作业一样，AD 代理会联系 Authing ，拉下该作业，在运行该代理的本地服务器上将其打开，然后执行该作业。代理首先执行整个 AD 结构的拓扑读取。代理接下来会更新用户和组，如果是增量导入，它将根据为每个对象读取的 usnChanged AD 属性值执行导入。*读取的对象范围将基于 AD 代理的导入设置。在 Authing 租户的 AD 集成设置中配置的内容。",
      tip: "以下是导入作业查询的示例：",
      overview2:
        "重要的是要记住，一旦服务器运行了导入，它将成为首选的导入服务器。这意味着后续的导入作业将被发送到同一台服务器。因此，如果将 AD 代理部署在多台服务器上，则导入作业将不会分散在所有这些服务器上。相反，它们将仅在当前首选服务器上执行。",
      overview3:
        "另外，重要的是要了解导入速度取决于目录的大小，导入范围和频率。例如，如果导入范围包含 10,000 个 OU，并且自上次导入以来已更新了数百万个用户，则导入范围将比导入 5,000 个 OU 和尚未更新的用户花费的时间更长。",
      warn: "注意：有关 Microsoft AD 的 usnChanged 属性的更多信息，请访问",
      code: {
        read: "拓扑阅读",
        account: "用户账户读取",
      },
    },
    synchrony: {
      title: "实时同步作业",
      overview1:
        "除了用户身份验证和用户导入之外，如果启用了即时（JIT）更新，则 Authing AD 代理还将执行实时同步作业。实时同步作业会在登录时更新用户属性，组成员身份，并在 Authing 中创建新组。为此，代理对随机选择的 AD 服务器执行 BIND。",
      overview2:
        "成功的 BIND 后，服务器会收到一个安全令牌，其中包含当前用户所属的组安全标识符（SID）列表。代理从此令牌中提取 SID，使用 SID 在其本地 SID 缓存中查找组，然后将成员资格发送给 Authing ，以使 Authing 可以将用户添加到组中。如果本地缓存中不存在 SID，则代理将在 AD 中搜索它们。",
    },
    install: {
      title: "安装 AD 代理并对其进行故障排除",
      overview1:
        "可以在 authing.cn/docs 中找到有关将 AD 代理安装到 AD 与 Authing 集成的 AD 代理的详细要求，过程和任务。为了帮助你进行故障排除，Authing 会在 AD 代理的日志中记录 AD 代理执行的 Windows 事件查看器操作。AD 代理日志存储在",
      overview2:
        "和 Windows 事件查看器中。如果需要其他日志记录信息，则可以启用详细日志。",
      overview3:
        "由于 AD 代理通过 HTTPS 与 Authing 通信，因此你可以使用 Web 监视工具（例如 Fiddler）捕获此流量。",
    },
    mix: {
      title: "融合和谐",
      overview1:
        "通过将 AD 和 Authing 与 Authing AD 代理集成，你可以充分利用现代应用程序，包括移动应用程序，SaaS 应用程序和本地应用程序。通过将这些应用程序添加到 Authing，可以自动为你的 AD 用户提供访问权限。Authing 还可以通过一套中央策略，自适应多因素身份验证（AMFA）甚至可以选择无密码来轻松保护对这些应用程序的访问。通过利用我们的 Authing RADIUS 代理和 Authing LDAP 接口，你甚至可以将 Authing 的某些安全功能扩展到本地网络设备，例如 Wi-Fi 路由器，VPN 和其他网络设备。",
      overview2:
        "借助集中式身份访问管理（IAM）和单个登录界面，用户可以访问所需的所有应用程序和服务，从而显着减少管理开销，加快应用程序部署，为用户提供更无缝和一致的访问权限并增强整体安全性具备更现代化的身份验证功能。",
      overview3:
        "过去，AD 已成为你环境中不可或缺的一部分，并且将来可以继续提供价值。但是，随着你通过此集成利用 Authing 带来的现代 IAM 的众多优势，你查看 AD 角色的方式可能会发生变化。Authing 打开了一个网关，可以轻松，安全地访问不断增长的现代应用程序和服务。利用我们与供应商无关的性质和集成网络，你可以通过 Authing 连接任何技术，从而为你推动业务创新和成功提供所需的灵活性。",
    },
  },
  buildIdaas: {
    banner: {
      title: "构建专属身份云，助力企业发展",
      subtitle:
        "随着企业逐渐加快数字化转型，「身份和访问管理」对于企业成功至关重要。完善的身份和访问管理解决方案可以决定数字转型计划的成败，成功的数字转型项目从一开始就包含「身份和访问管理」解决方案。",
    },
    intro: {
      descript1:
        "对于在「无边界和数字世界」中竞争的企业来说，保护敏感系统和客户机密数据则至关重要。然而，当下的网络安全状况却并不乐观。当客户数据因为企业的维护不当而被滥用或窃取时，企业不仅会蒙受业务损失，甚至有可能还要面临巨额的合规罚款以及其他法律处罚。",
      descript2:
        "根据 2016-2019 年的数据显示，中国企业 IT 支出占全球比重和 GDP 相对比来看，中国企业的数字化程度正处在高速增长中。当企业逐渐从 2020 的全球疫情影响中恢复过来时，他们也将面临大量的 IT 项目积压，然而，用于完成这些项目的资金却是有限的。",
      descript3:
        "因此，建设身份云 IDaaS 将帮助企业更快实现数字化转型，减轻财务负担，也能有效避免给企业发展制造障碍增加不必要的成本。",
    },
    features: {
      title: "Authing 已帮助 30000+ 家企业和开发者构建标准化的用户身份体系",
      item1: {
        title: "完善的身份服务",
        descript:
          "传统 IAM 账号中心的运营能力较弱，难以满足大型组织在业务方面的需求，而 IDaaS 的多租户运营平台和自动化工作流（Workflow）则可以便捷地提升企业运营效率。",
      },
      item2: {
        title: "降低企业开发成本",
        descript:
          "订阅 Authing 将节约构建身份管理系统的成本，并减轻未来维修升级的负担。解放出来的人力物力可让开发团队专注于核心业务，为企业的创新能力开发出新的增长空间，也加快产品交付上市的时间。",
      },
      item3: {
        title: "提升运营管理效率",
        descript:
          "大型企业和组织的内部通常会根据“地域”、“部门”等维度进行业务划分，不同业务通常需要保证独立性，Authing 身份云利用多租户技术帮助企业解决业务和数据的隔离问题。",
      },
      item4: {
        title: "提升身份安全",
        descript:
          "动态令牌，人脸识别等多因素认证（MFA）功能，全面提高系统访问安全，保障用户访问安全。",
      },
      item5: {
        title: "提高系统的可扩展性",
        descript:
          "一旦购买身份管理 API 开发包，开发团队可在平台上对所需开发的应用进行集成，无需重复构建、购买身份管理方案，对开发者十分友好。",
      },
    },
    list: {
      title: "标准身份云需要包含的功能清单",
      subtitle:
        "以下是一套标准的身份云 IDaaS 需要包含的功能清单，当然，每一个企业都有自己独有的组织形式和业务模式。",
      table: {
        firstHead: "一级功能",
        secondHead: "二级功能",
        thirdHead: "说明",
        item1: {
          title: "统一账户",
          content: {
            subtitle1: "用户管理",
            descriptions1: {
              description1: "用户批量导入、导出",
              description2: "用户帐号的逐条/批量的增/删/改/查",
              description3: "用户属性管理（基础字段+自定义字段)",
              description4: "用户状态管理（启用/解锁/停用/激活等）",
              description5: "用户密码重置",
            },
            subtitle2: "组织管理",
            descriptions2: {
              description1: "多级组织架构树",
              description2: "组织管理",
            },
            subtitle3: "用户组管理",
            descriptions3: {
              description1: "用户组创建/查询/删除等",
              description2: "用户组属性管理",
            },
            subtitle4: "目录同步",
            descriptions4: {
              description1: "账户同步（上游同步）",
            },
          },
        },
        item2: {
          title: "统一认证",
          content: {
            subtitle1: "认证源管理",
            descriptions1: {
              description1:
                "支持认证源配置，支持添加企业微信、AD 认证源、LDAP 认证源；支持自定义认证源，包括基于 OpenID、SAML、CAS 协议的认证源",
            },
            subtitle2: "认证方式",
            descriptions2: {
              description1:
                "支持多因子认证，包括账户名/密码、OTP、二维码、社交登录认证等",
            },
            subtitle3: "认证配置",
            descriptions3: {
              description1: "支持针对不同的应用配置不同的认证因子",
            },
          },
        },
        item3: {
          title: "统一应用",
          content: {
            subtitle1: "应用管理",
            descriptions1: {
              description1:
                "支持应用预集成；支持创建自定义应用（OpenId Connect、FormPost、SAML2.0、CAS、OIDC 等标准协议）",
            },
            subtitle2: "单点登录",
            descriptions2: {
              description1: "支持为应用配置单点登录 SSO",
            },
            subtitle3: "账号供给",
            descriptions3: {
              description1: "支持将账号、机构等同步到应用系统",
            },
            subtitle4: "SaaS 服务接入能力",
            descriptions4: {
              description1:
                "支持通过 OIDC、SAML、CAS、LDAP、AD 等标准协议集成第三方 SaaS 或企业自建应用",
            },
            subtitle5: "租户级别应用接入能力",
            descriptions5: {
              description1: "支持根据 IDaaS 身份云的不同租户接入不同应用",
            },
            subtitle6: "工作台集成",
            descriptions6: {
              description1: "支持企业微信工作台；支持添加工作台",
            },
          },
        },
        item4: {
          title: "统一权限",
          content: {
            subtitle1: "权限管理",
            descriptions1: {
              description1: "支持应用级授权；支持基于 RBAC 的授权",
            },
            subtitle2: "权限配置",
            descriptions2: {
              description1: "支持基于用户/用户组/机构等授权",
            },
            subtitle3: "权限同步",
            descriptions3: {
              description1: "支持应用权限的同步",
            },
          },
        },
        item5: {
          title: "统一审计",
          content: {
            subtitle1: "用户操作日志",
            descriptions1: {
              description1: "支持用户操作日志的查询、导出",
            },
            subtitle2: "管理员操作日志",
            descriptions2: {
              description1: "支持管理员操作日志的查询、导出",
            },
          },
        },
        item6: {
          title: "安全管理",
          content: {
            subtitle1: "管理员配置",
            descriptions1: {
              description1:
                "支持管理员/管理员组的创建、删除等；支持配置不同管理员角色",
            },
            subtitle2: "安全策略",
            descriptions2: {
              description1:
                "支持密码策略配置，包括密码强度设置、密码重置设置、登录安全设置等",
            },
          },
        },
        // item7: {
        //   title: "应用接入能力",
        //   content: {
        //     subtitle1: "SaaS 服务接入能力",
        //     subtitle2: "租户级别应用接入能力",
        //   },
        // },
        item8: {
          title: "多租户运营管理及运维能力",
          content: {
            subtitle1: "IDaaS 租户运营平台",
            descriptions1: {
              description1:
                "企业运营中心支持对身份云内的所有租户、应用、订单等进行集中管理；核心数据可视化",
            },
            subtitle2: "IDaaS 运维平台",
            descriptions2: {
              description1:
                "一键部署属 IDaaS 平台，系统运维、数据监控、服务升级尽在掌控",
            },
          },
        },
      },
    },
  },
  cognito: {
    banner: {
      title: "全面替代 AWS Cognito",
      subtitle:
        "Authing 可以解决使用 Cognito 的诸多问题，使用 Authing User Pool， 可以全面替代 Cognito User Pool，构建起国内用户与 AWS 资源之间的桥梁。",
    },
    intro: {
      descript1:
        "在 Web 或 App 开发过程中，用户的认证和权限处理是非常重要的一个模块，这里包括用户注册、登录认证及管理对应的权限。除了用户名密码登录外，通过第三方社交帐号登录也是非常重要的需求，在国外主要是 Google、Facebook 或 Apple 登录等，而在国内则主要是微信、微博登录等。",
      descript2:
        "身份认证与授权实现起来相应复杂，因此在 AWS 云上提供了 Cognito 服务，以帮助开发者更快、更安全地接入用户注册/登录和访问控制功能。Cognito 服务让企业可以把更多的精力花在核心业务上，去关注创新、创收，而非过多关注身份认证与授权相关的底层技术细节。",
    },
    value: {
      title:
        "AWS Cognito User Pool 服务在国内区域暂时未上线，对于想要在中国使用 Cognito 这类 IDaaS 服务的企业来说，Authing 将是更好的选择。Authing 可以解决使用 Cognito 的诸多问题，使用 Authing User Pool，可以全面替代 Cognito User Pool，构建起国内用户与 AWS 资源之间的桥梁。",
      item1: {
        title: "架构设计",
        subtitle: "演示网站整体架构",
        list1:
          "通过 S3 进行静态网站托管, 并利用 Cloudfront 进行静态内容加速和 HTTPS 证书挂载。",
        list2:
          "通过 Authing 进行登录认证并获取令牌，作为 User Pool 的替代方案。",
        list3: "访问 API Gateway 提供的 REST API。",
        list4:
          "通过 Cognito Identity Pool 获取临时 AWS 凭证，访问 AWS 资源（这里以 Polly 服务为例）。",
        tip: "演示网站目前已部署在 AWS 国内区域, 进行简单的用户注册后可以",
        link: "查看访问效果",
        img:
          "//files.authing.co/authing-website/solution-cognito-framework-design.png",
      },
      item2: {
        title: "通过 Authing 进行登录认证并获取令牌",
        subtitle:
          "Authing 基于 OIDC 和 OAuth 2.0 对用户进行身份验证，并授予用用户访问对应的应用的权限。",
        list1:
          "用户通过 Authing 用户池请求登录，并在成功进行身份验证后，从服务器获取到 code。",
        list2: "应用程序通过身份池带着 code 请求 token。",
        list3: "用户可以使用 token 来请求访问各种应用资源。",
        imgText:
          "上图介绍了 OIDC Authorization Code Flow 来获取 Token, 用户也可以通过 OIDC Implicit Flow 来获取 Token。本示例使用的是 Implicit Flow，",
        link: "查看对比",
        img:
          "//files.authing.co/authing-website/solution-cognito-login-token.png",
      },
      item3: {
        title: "访问 API Gateway 提供的受保护的 REST API",
        subtitle:
          "通过 Authing 登录认证后，可获取令牌（即 id_token）。通过发送 HTTP 请求时在 header 携带令牌，即可访问受保护的 REST API。",
        img:
          "//files.authing.co/authing-website/solution-cognito-api-gateway.png",
      },
      item4: {
        title: "通过与 Identity Pool 集成安全访问 AWS 服务",
        subtitle:
          "通过 Authing 登录认证后，可获取令牌（即 id_token）。通过与 Identity Pool 集成来获取临时凭证，进而安全地访问 AWS 资源。",
        img:
          "//files.authing.co/authing-website/solution-cognito-identity-pool-v2.png",
      },
    },
  },
  // cognito: {
  //   title: "全面替代 AWS Cognito",
  //   subtitle:
  //     "Authing 可以解决使用 Cognito 的诸多问题，使用 Authing User Pool， 可以全面替代 Cognito User Pool，构建起国内用户与 AWS 资源之间的桥梁。",
  //   extra: "* 内容来自亚马逊 AWS 官方博客",
  //   intro: {
  //     title: "AWS Cognito 简介",
  //     descript1:
  //       "在 Web 或 App 开发过程中，用户的认证和权限处理是非常重要的一个模块，这里包括用户注册、登录认证及管理对应的权限。除了用户名密码登录外，通过第三方社交帐号登录也是非常重要的需求，在国外主要是 Google、Facebook 或 Apple 登录等，而在国内则主要是微信、微博登录等。",
  //     descript2:
  //       "身份认证与授权实现起来相应复杂，因此在 AWS 云上提供了 Cognito 服务，以帮助开发者更快、更安全地接入用户注册/登录和访问控制功能。Cognito 服务让企业可以把更多的精力花在核心业务上，去关注创新、创收，而非过多关注身份认证与授权相关的底层技术细节。",
  //   },
  //   project: {
  //     title: "替代方案",
  //     item1: {
  //       title: "架构设计",
  //       subtitle: "演示网站整体架构",
  //       list1:
  //         "通过 S3 进行静态网站托管, 并利用 Cloudfront 进行静态内容加速和 HTTPS 证书挂载。",
  //       list2:
  //         "通过 Authing 进行登录认证并获取令牌，作为 User Pool 的替代方案。",
  //       list3: "访问 API Gateway 提供的 REST API。",
  //       list4:
  //         "通过 Cognito Identity Pool 获取临时 AWS 凭证，访问 AWS 资源（这里以 Polly 服务为例）。",
  //       tip: "演示网站目前已部署在 AWS 国内区域, 进行简单的用户注册后可以",
  //       link: "查看访问效果",
  //     },
  //     item2: {
  //       title: "通过 Authing 进行登录认证并获取令牌",
  //       subtitle:
  //         "Authing 基于 OIDC 和 OAuth 2.0 对用户进行身份验证，并授予用用户访问对应的应用的权限。",
  //       list1:
  //         "用户通过 Authing 用户池请求登录，并在成功进行身份验证后，从服务器获取到 code。",
  //       list2: "应用程序通过身份池带着 code 请求 token。",
  //       list3: "用户可以使用 token 来请求访问各种应用资源。",
  //       imgText:
  //         "上图介绍了 OIDC Authorization Code Flow 来获取 Token, 用户也可以通过 OIDC Implicit Flow 来获取 Token。本示例使用的是 Implicit Flow，",
  //       link: "查看对比",
  //     },
  //     item3: {
  //       title: "访问 API Gateway 提供的受保护的 REST API",
  //       subtitle:
  //         "通过 Authing 登录认证后，可获取令牌（即 id_token）。通过发送 HTTP 请求时在 header 携带令牌，即可访问受保护的 REST API。",
  //     },
  //     item4: {
  //       title: "通过与 Identity Pool 集成安全访问 AWS 服务",
  //       subtitle:
  //         "通过 Authing 登录认证后，可获取令牌（即 id_token）。通过与 Identity Pool 集成来获取临时凭证，进而安全地访问 AWS 资源。",
  //     },
  //   },
  //   replace: {
  //     title: "用 Authing 替换 AWS Cognito",
  //     item1: {
  //       title: "痛点",
  //       subtitle:
  //         "AWS 虽然作为市场份额全球第一的云计算厂商，但 Cognito 服务却无法在中国大陆地区使用。对于想要使用 Cognito 这类 IDaaS 服务的企业来说，Authing 便是替代 Cognito 的不二选择。",
  //     },
  //     item2: {
  //       title: "Authing 的价值",
  //       subtitle:
  //         "Authing 可以解决使用 Cognito 的诸多问题，使用 Authing User Pool，可以全面替代 Cognito User Pool，构建起国内用户与 AWS 资源之间的桥梁。",
  //     },
  //   },
  //   deploy: {
  //     title: "方案部署",
  //     subtitle1: "演示网站的前端和后端代码均已发布在",
  //     subtitle2: "可参照相关代码进行部署和测试",
  //     item1: {
  //       title: "Authing 帐号开通与 OIDC 应用配置",
  //       subtitle1:
  //         "首先需要先在 Authing 中创建 OIDC 应用，具体可以参考 Authing 相关的",
  //       subtitle2:
  //         "。这个演示环境使用的是 Implicit Flow，并使用 RS256 算法进行 id_token 签名，可参考左图进行回调 URL、授权模式、返回类型等设置",
  //       imgText: "回调 URL、授权模式、返回类型等设置",
  //       link: "帮助文档",
  //     },
  //     item2: {
  //       title: "通过 SAM 部署 API Gateway 与 Lambda",
  //       subtitle1:
  //         "由于 id_token 使用 RS256 算法进行加密，因此需要在 Lambda Authorizer 中设置相应密钥，以便进行 token 验证。具体可以参考示例代码 app.js 中的相关注释",
  //       subtitle2:
  //         "演示环境中 API Gateway 及相关 Lambda 已经描述在一个 AWS SAM 模板中，通过 SAM 可以直接进行自动部署：",
  //       link: "查看文档",
  //     },
  //     item3: {
  //       title: "Authing 与 Identity Pool 集成的配置",
  //       subtitle:
  //         "同时，Cognito Identity Pool 会分别创建两个 IAM Role（针对认证用户和匿名用户），需要对认证用户的 IAM Role 进行权限设定，示例网站使用了 Polly 服务，因此需要添加访问 Polly 的权限。",
  //       config: "配置",
  //       configTip: "配置 OIDC Provider",
  //       provider: "Provider URL",
  //       providerTip: "即为 Authing 应用对应的 issuer",
  //       audience: "Audience",
  //       audienceTip: "即为 Authing 应用对应的 App ID",
  //       doc: "参考文档",
  //       docTip: "具体配置可参考 AWS 相关官方文档",
  //       configIdentity: "配置",
  //       configIdentityTip: "配置 Cognito Identity Pool",
  //       authenticated: "Authenticated Provider",
  //       authenticatedTip: "指定 Authing 做为 Authenticated Provider",
  //       imgText: "创建成功示例",
  //       demoLink: "查看示例",
  //       docLink: "查看文档",
  //     },
  //     item4: {
  //       title: "部署静态网站做为前端演示",
  //       subtitleTitle: "前端演示页面 ：",
  //       subtitle:
  //         "可以上传到 S3 桶，并开启 S3 静态网站托管功能，注意需要在前面增加 Cloudfront 并添加 HTTPS 证书；或者可以选择部署在一台 EC2 上。",
  //     },
  //   },
  // },

  keycloak: {
    banner: {
      title: "全面替代 Keycloak",
      description: `长远来看，与 keycloak 相比，Authing 更能为企业与开发者省事——开箱即用，无需投入大量自研成本，满足中国的安全资质要求，提供快速响应的技术支持。`,
      solution: "下载解决方案",
      consult: "方案咨询",
    },
    replace: {
      title: "为什么选择 Authing 替代 Keycloak？",
      subtitle:
        "基于开源软件自研身份认证与管理系统，仍需投入大量的技术成本，且有较高的安全风险",
      authing: {
        title: "使用 Authing",
        subtitle: "享受开箱即用的身份认证产品",
        item1: {
          title: "安全合规完善",
          descript:
            "Authing 有完善的安全防护策略，能依照企业需求进行设置；也拥有 ISO、三级等保、GDPR 等数据安全认证，能满足中国大陆的合规要求。",
        },
        item2: {
          title: "投入成本低",
          descript:
            "Authing 提供成熟的 IDaaS 产品，同样支持单点登录、身份认证、权限管理等功能，配合完善的技术文档，能大幅缩短企业的开发时间。",
        },
        item3: {
          title: "运营维护轻松",
          descript:
            "Authing 作为企业级软件，经常升级功能、修补漏洞，无需企业自行维护；产品不仅容易上手，还有丰富的实施经验能帮助企业更高效地进行建设。",
        },
        item4: {
          title: "客户服务活跃",
          descript:
            "针对企业客户，Authing 提供专属的客户成功经理，平均能在 20 分钟内进行响应；针对个人开发者，也有完善的开发者论坛，为用户答疑解惑。",
        },
      },
      keycloak: {
        title: "使用 Keycloak",
        subtitle: "面临开源软件的隐藏缺陷",
        item1: {
          title: "安全合规不符",
          descript:
            "开源软件的代码有机会被黑客直接访问，并且较难依据企业的网络安全情况，定制合适的 IAM 安全策略；也较难满足中国严格的安全合规要求。",
        },
        item2: {
          title: "研发成本高",
          descript:
            "开源软件不是完全免费的。企业基于 keycloak 开发身份认证与权限管理系统，仍需投入大量的技术成本，才能确保系统符合业务需要。",
        },
        item3: {
          title: "运营维护困难",
          descript:
            "开源软件修复 Bug 的方式，容易使源代码出现结构问题，导致企业难以维护；对于特定技术问题，也较难在开源社区中快速找到可靠的解决方案。",
        },
        item4: {
          title: "售后服务缺乏",
          descript:
            "Keycloak 属于免费的开源项目，没有固定的开发者支持，也没有迅速响应的客户成功服务。若遇到紧急的问题，安全和效率方面缺乏保障。",
        },
      },
    },
    marquee: {
      item1: {
        title1: "某全球知名在线教育平台",
        desc1:
          "该平台不仅开放各种课程，更开放了教学的机会；目前已服务了 180 个国家的 7800 万用户",
        title2: "免除自研成本，快速开发上线",
        desc2:
          "进入中国市场，我们原先想基于 keycloak 来自研身份认证系统，但赶不上计划时间，也不满足中国的合规需求。因此，我们选择了 Authing 来快速集成多端的身份认证——两周左右就开发完成了，同时也符合安全法规。这为我们的拓展业务打下扎实的基础。",
      },
      item2: {
        title1: "某 TOP 基金服务商",
        desc1: "一家深度运用互联网技术、深度耕耘泛资管行业的创新型金融科技公司",
        title2: "降低运维成本，轻松配置管理",
        desc2:
          "随着业务快速扩张，原有的 keyclaok 开源方案和手动维护方式，难以支持我们产品和系统的不断上新。迁移至 Authing 后，我们构建了统一身份管理平台，来集中配置和管理账号，形成统一的权限分配和审计，极大降低了我们的维护成本，有效提升了安全性。",
      },
    },
    table: {
      title: "使用 Authing，快速上线完善的身份体系",
      description:
        "与 Keycloak 相比，Authing 的商业支持更加完备，建设经验也更为丰富，能真正地帮助企业提升身份管理的 ROI。",
      fun: "功能",
      fun1: "默认支持的标准认证协议",
      fun2: "Web 和移动应用程序的身份验证",
      fun3: "连接自定义数据库",
      fun4: "细粒度的权限控制",
      fun5: "登录表单组件",
      fun6: "动态自适应多因素认证",
      fun7: "审核日志",
      fun8: "支持多种 SDK",
      fun9: "自定义用户数据",
      fun10: "密码泄漏检测（实时）",
      fun11: "Webhooks 和事件",
      fun12: "支持多租户应用",
      fun13: "语言国际化",
      fun14: "强数据隔离",
      fun15: "自定义密码加密算法",
      fun16: "高级许可和合规管理",
      fun17: "暴力破解检测",
      fun18: "连接自定义社会化登录",
      keycloak: "目前只支持 OIDC 和 SAML 2.0",
      authing: "OAuth 2.0, OIDC, SAML, AD/LDAP 等",
    },
  },
  mfa: {
    banner: {
      title: "自适应 MFA",
      subtitle:
        "启用多因素认证后，用户进行操作时，除了需要提供用户名和密码外（第一次身份验证），还需要提供验证码（第二次身份验证），多因素身份认证结合起来将为你的账号和资源提供更高的安全保护。",
    },
    challenge: {
      title: "现代企业和组织面临的挑战",
      subtitle:
        "大数据、互联网、5G 的迅速发展，在为人类带来无限发展机遇的同时，也催生了大量的信息泄露事件。根据《IBM 2020 年数据泄露报告》显示，数据泄露的平均总成本为 386 万美元（约合人民币 2521 万元）",
      description1:
        "对企业来说，数据泄露的代价越发严重。一方面，企业会受到监管机构处罚，比如英国航空因数据泄露被英国信息专员办公室 (ICO) 罚款 2.04 亿欧元。另一方面，一旦发生数据泄露，不仅会让企业失去客户和用户的信任，而且影响公司长期发展。",
      description2:
        "因此，使用多因素认证（下文统称为 MFA），变成为企业防止数据泄露的基本手段。多因素认证要求用户使用至少两个因素对身份进行验证，验证通过后才能访问应用程序，这在企业中正快速普及。",
      description3:
        " 去年底， LastPass 对 4.7 万个企业进行了一项调查，发现全球目前有 57％ 的企业正在使用多因素认证，比上一年增长了 12％。统计数据也证明了 MFA 的有效性。今年早些时候，微软报告称，其追踪的违规账户中有 99.9％ 没有使用多因素认证。",
    },
    features: {
      title: "Authing 多因素认证核心功能",
      item1: "Authing 通过多种认证方式，保障业务安全",
      item2: "认证流程自定义，一键开启，操作简单",
      item3: "支持设备环境数据上报，多维度分析安全级别",
      item4: "支持配置策略，实现环境风险自适应",
      item5: "同时适用于应用内权限控制场景",
      item6: "默认集成于通用登录组件（Guard）",
      item7: "用户数据管理、行为日志查询",
      item8:
        "提供 SDK 与开放接口，助力开发者快速调用相关能力，并构建自定义的用户管理页面",
    },
    mode: {
      title: "多种认证方式，提高企业身份安全性",
      item1: {
        title: "手机令牌",
        list1:
          "通过安全性强的动态 OTP 口令验证，帮助保护账户安全，避免恶意攻击。",
      },
      item2: {
        title: "短信/邮箱验证码",
        list1: "操作简单",
        list2: "方便快捷",
        list3: "提高登录安全性",
      },
      item3: {
        title: "兼容第三方身份验证器",
        list1: "兼容第三方身份验证器",
        list2:
          "避免无法接收验证短信的痛苦，无需联网也可用，手机欠费停机不影响。",
      },
      item4: {
        title: "生物识别",
        list1: "指纹/人脸作为人体特征的关键因素，在安全认证领域被广泛应用。",
        list2: "高安全、高精度，无需输入密码即可完成认证。",
      },
      item5: {
        title: "图形锁",
        list1: "简单易上手",
        list2: "可通过更复杂的图形增强安全性",
      },
      item6: {
        title: "小程序认证",
        list1:
          "将 Authing 移动令牌验证器集成至微信小程序，免去安装 APP 的流程，快捷使用移动端验证器。",
      },
    },
    advantage: {
      title: "Authing 多因素认证的优势",
      subtitle:
        "赋能 Authing 应用快速启用多因素认证（MFA），即刻提升应用认证与访问安全等级",
      item1: {
        title: "开发者友好",
        subtitle: "提供开箱即用的端 SDK，方便端上开发者快速实现 MFA",
        list1: "· 支持多端：Web、iOS、Android",
        list2:
          "· 内置多种多因素认证端组件，如 OTP、验证码、指纹解锁、面部识别、图形锁等",
        list3:
          "· 仅需调用一个方法，就可唤起 MFA 认证组件，拿到认证结果，完成认证流程",
      },

      item2: {
        title: "定制数据上报",
        subtitle: "定制数据上报，参与流程发起决策，覆盖更加复杂精细化场景",
        list1: "· 支持在 Authing SDK 初始化时数据上报",
        list2: "· 支持定时数据上报",
        list3: "· 支持应用运行时主动数据上报",
      },
      item3: {
        title: "基于策略",
        subtitle:
          "多因素认证的触发条件基于自定义策略，策略系统简单、高效、完备、灵活",
        list1:
          "· 简单：不想配复杂的策略，可以使用 默认安全策略 或预设好的 命中条件",
        list2:
          "· 高效：毫秒级判断策略命中，多因素认证即刻唤起；基于有好的用户界面 ",
        list3:
          "· 完备：策略基于函数表达式描述，开发者可以获取到足够多的信息（包括但不限于用户信息、设备、网络、位置、行为、自定义上报数据等）来书写策略命中逻辑 ",
        list4: "· 灵活：可同时基于多种方式进行命中判断",
      },
      item4: {
        title: "配置简单",
        subtitle: "基于友好的用户界面，快速配置具体应用的多因素认证",
        list1: "· 一键开启/关闭多因素认证 ",
        list2:
          "· 一键启用默认安全策略，不必理解策略配置，也能使应用安全性得到很大提高",
        list3:
          "· 预设十几种重要且常用的策略命中条件，即选即生效，不是工程师也能使用",
      },
    },
    performance: {
      title: "自适应多因素认证，更高性能的选择",
      subtitle:
        "「自适应」多因素认证较于传统多因素认证，能够根据当前安全状况，选择应用不同的 MFA 方式，在保障安全的同时也兼顾用户体验。「自适应」多因素认证提供了更加灵活和智能的验证策略。",
      secondTitle:
        "在用户进行认证流程时，「自适应」多因素认证对当前登录的用户生成的多种 「关键要素」",
      item1: {
        title: "用户属性",
        subtitle: "例如用户名、密码、用户身份等用户自身的属性和信息",
      },
      item2: {
        title: "位置感知",
        subtitle: "位置感知分为虚拟位置（IP 地址）和物理位置（国家、地区等）",
      },
      item3: {
        title: "请求来源",
        subtitle:
          "对当前用户的请求来源进行判断，如：硬件设备信息、用户当前所在的系统等",
      },
      item4: {
        title: "生物识别",
        subtitle: "使用用户的生物信息进行识别，如：指纹信息、人脸识别等",
      },
      item5: {
        title: "行为分析",
        subtitle:
          "是否来自常用的登录地点、是否多次输入错误密码、用户之前的操作记录等一系列用户行为",
      },
    },
    example: {
      title: "行业用例",
      subtitle:
        "通常，我们看到在处理敏感数据的行业 (如保险和银行) 倾向于使用 MFA。这些垂直领域没有额外的身份层，所以对 MFA 的需求迫切",
      description1:
        "多因素认证是防止账户被盗取有效的方法之一。攻击者如果想要入侵受 MFA 保护的帐户，不仅需要盗取凭证，还需要验证额外附加的因素。多因素认证极大地增加了攻击者入侵帐户所需的时间和精力，这样他们就很难进行大规模的攻击活动。",
      description2:
        "Authing 可集中配置多种密码以外的认证因子，包括动态令牌、证书、人脸、指纹等生物特征。可集成多种常见第三方认证源。同时提供开发者 API，支持其他应用使用 IDaaS 的身份认证能力。",
      systems: {
        finace: "金融系统",
        item1: {
          title: "确保对财务数据的访问",
          subtitle:
            "使用 Authing 的多因素认证（MFA）验证用户的身份，以保护金融数据和在线交易免受犯罪分子的侵害。",
          list1:
            "登入金融网站和 app 时，Authing 的 MFA 通过向用户的智能手机发送验证信息，以防止未经授权的访问。",
          list2:
            "进行金融交易时，Authing 的 MFA 对用户身份进行双重验证，确保交易对象身份安全，保护在线交易免受犯罪分子的侵害。",
        },
        education: "教育系统",
        item2: {
          title: "保护高等教育",
          subtitle:
            "使用 Authing 值得信赖的 MFA 解决方案，为学生、教职员工提供安全的应用程序访问。",
          list1:
            "Authing 通过多因素认证（MFA）来验证用户身份，并在授予对网页、应用的访问权限之前检查其设备的安全状况，以此确保只有受信任的用户和设备才能访问其机构网站和应用。",
          list2:
            "将 MFA 部署到其师生群体之后，以提高身份验证的准确性并确保学生、教职员工不会成为网络钓鱼攻击的受害者。",
        },
        govenment: "政务系统",
        item3: {
          title: "为政府机构实现安全",
          subtitle:
            "使用 Authing 多因素认证（MFA）解决方案，开启“零信任”之旅，帮助政府机构降低风险，推进政务现代化的实现。",
          list1:
            "地方政府依靠各种工具来管理敏感的个人信息并提供基本的社区服务，部署 Authing 的 MFA，可以稳定保持政务应用的安全性，改善政务应用的安全状况。",
          list2:
            "Authing 通过防止设备未经授权访问应用程序，从而抵御钓鱼网站和勒索软件攻击的威胁。政府机构可以安全轻松地访问网站与应用，为社区服务，无需管理复杂的 IT 环境。",
        },
      },
    },
  },
  buildAd: {
    banner: {
      title: "全面增强微软 AD 身份方案",
      subtitle:
        "过去，企业依赖 AD（Active Directory）用于验证资源访问，而如今已不足够。",
      subtitle2: "现在，你需要更灵活的身份增强方案，来配合企业的高速发展。",
    },
    intro: {
      item1: {
        title: "增强微软 AD，提升企业信息化转型效率",
        subtitle: "传统的 Active Directory 方案",
        "descript1-title": "仅支持 LDAP 、Kerberos 协议：",
        descript1: "未来难以接入更多云上云下的应用。",
        "descript2-title": "使用场景单一：",
        descript2:
          "只能做到统一认证，难以实现单点登录（SSO）、应用集成、数据同步等能力。",
        "descript3-title": "不符合信息化需求：",
        descript3: "难以访问非本地资源与云服务资源、只能做域内的权限控制。",
        "descript4-title": "扩展性低、配置复杂：",
        descript4: "缺乏 API 和扩展能力，IT 运维、Bug 修复等成本负担大。",
      },

      item2: {
        title: "未来的身份体系",
        "descript1-title": "更方便的集成：",
        descript1:
          "除了 LDAP，更支持 OIDC、OAuth2.0、SAML、CAS 等多种协议，及 2000+ 常见应用的接入。",
        "descript2-title": "更多元的功能：",
        descript2:
          "使用 Authing 作为现代化目录，能同时实现 AD 单点登录、生命周期管理、多因素身份认证等功能。",
        "descript3-title": "更细粒度的授权：",
        descript3: "支持 RBAC/ABAC 权限模型、应用访问授权等授权。",
        "descript4-title": "更高的扩展性：",
        descript4:
          "丰富 SDK/API、登录组件、Serverless 能力，灵活配合业务需求、减少运维工作量。",
      },

      item3: {
        title: "AD 身份解决方案，交给 Authing AD Connector",
        descript1:
          "为企业用户提供基于 Windows AD 的身份验证服务，将 AD 的用户和组织机构进行无缝迁移。",
        descript2:
          "让微软 AD 与 Authing 共存——AD 管理硬件层，Authing 管理软件业务层，支持两者数据双向同步。",
      },

      item4: {
        title: "转换是值得的",
        descript:
          "选择 Authing 意味着收回对身份验证过程和数据的控制。 从今天开始，Authing 可以帮助你完成转换。",
      },
    },
    features: {
      title: "重新考虑 AD 成熟度模型",
      axisX: "业务现代性",
      axisY: "业务敏捷性",
      item1: {
        title: "现状",
        list1: "所有存储在 AD 中的用户",
        list2: "AD 控制所有机器并通过 GPO 进行访问",
        list3: "SaaS 使用独立登录",
      },
      item2: {
        title: "用单点登录扩展 AD",
        list1: "IDaaS 与 AD 集成，支持对 SaaS 和本地应用的单点登录",
        list2: "IDaaS 集中安全策略",
        list3: "MFA 保护应用程序和资源",
      },
      item3: {
        title: "建立 IDaaS 身份中心",
        list1: "IDaaS 直接从人力资源采购员工，并将其分配给 AD",
        list2: "本地由 IDaaS 管理的非员工",
        list3: "设备管理解决方案控制最终用户设备",
      },
      item4: {
        title: "安全身份云",

        list1:
          "IDaaS 通过自适应策略和无密码身份验证来控制对所有应用程序和资源的访问",
        list2: "设备管理和 IDaaS 解决方案共享设备和用户上下文",
        list3: "IDaaS 保护对服务器和网络资源（如 VPN，WiFi）的访问",
        list4: "SaaS 文件同步和共享解决方案取代文件服务器",
        list5: "云打印服务取代打印服务器",
      },
    },
  },
  privateCloud: {
    banner: {
      title: "私有部署身份云",
      subtitle:
        "Authing 作为企业级的身份管理服务，不仅是软件商，更是企业的业务咨询伙伴，Authing 已经为多家世界五百强企业构建了专属 IDaaS 服务。",
    },
    resource: {
      title: "资源中心",
      mirror: {
        title: "私有化部署方案",
        content: "如果你需要私有化部署 Authing，点击了解部署方案",
        "button-link": "立即查看",
      },
      docs: {
        title: "快速开始",
        content: "为你的应用轻松集成身份系统，指引部署遇到的问题",
        "button-link": "立即查看",
      },
      "price-title": "Authing 为你的企业量身打造专属身份云 IDaaS 服务",
    },
    advantage: {
      title: "优势介绍",
      item1: {
        title: "提升运营管理效率",
        content:
          "大型企业和组织的内部通常会根据“地域”、“部门”等维度进行业务划分，不同业务通常需要保证独立性，Authing 身份云利用多租户（multi-tenant）技术帮助企业解决业务和数据的隔离问题。同时 Authing 的企业运营中心可以帮助管理员对租户进行便捷的管理和运营。",
      },
      item2: {
        title: "完善的身份服务，改善用户体验",
        content:
          "身份管理贯穿企业为用户所提供的全部服务，一个优秀的身份管理方案将从用户注册登录，到服务中追踪用户的偏好，再到精准营销，全方位抓取并安全储存用户信息。",
      },
      item3: {
        title: "提升身份安全，保障数据资产",
        content:
          "动态令牌，人脸识别等多因素认证(MFA)功能，全面提高系统访问安全，保障用户访问安全。",
      },
      "customer-common":
        "“对比过众多厂商后更能感受到 Authing 的优势，这是一款经过思考做出来的产品”",
      "customer-link": "阅读客户成功案例",
      integrate: {
        title:
          "Authing 通过以下「三个步骤」为企业建设身份基础设施加速应用开发和集成：",
        item1:
          "前期进行详尽的需求采集和调研，深入了解到企业业务现状，结合实际场景，梳理出详尽的 IDaaS 建设方案和工程排期。",
        item2:
          "方案确认后，利用 Authing 的云原生架构优势，将 Authing 内核部署至企业私有云环境中，并利用已有的 700+ API 进行灵活快捷的二次开发，直至完成交付。",
        item3:
          "交付成功只是刚刚开始，作为企业级的身份管理服务，Authing 不仅是软件商，更是企业的业务咨询伙伴，Authing 拥有一支经验丰富的客户成功团队，7*24 小时为企业的身份安全保驾护航，同时为企业提供技术和业务的咨询服务。",
      },
    },
    question: {
      title: "常见问题",
      item1: {
        title: "如何选择认证方式？",
        list1:
          "若你不理解什么是 OAuth、OIDC、SAML、LDAP 等标准协议且应用安全性要求不高，建议使用普通认证；",
        list2:
          "若你的应用安全性要求较高，无论是否了解标准协议，请使用标准协议认证。",
      },
      item2: {
        title: "Authing 是什么？",
        list1: "Authing 在云上为企业和开发者提供专业的身份认证和授权服务。",
        list2:
          "你可以将任意平台的应用接入到 Authing（无论是新开发的应用还是老应用都可以），同时你还可以自定义应用程序的登录方式（如：邮箱/密码、短信/验证码、社会化登录等）。",
        list3:
          "你可以根据你使用的技术，来选择我们的 SDK 或调用相关 API 来接入你的应用。当用户发起授权请求时，Authing 会帮助你认证他们的身份和返回必要的用户信息到你的应用中。",
      },
      item3: {
        title: "为什么要使用 Authing？",
        list1:
          "你想开发一个很酷的程序，这时你想添加用户身份认证和授权。你希望你的用户能使用微信、Github 登录，同时你还希望能追踪到用户的注册来源，活动数据，以便你做后续的用户增长。",
        list2:
          "你做了一个 API，同时你希望能使用 OAuth 2.0 协议保证 API 的安全。",
        list3:
          "你做了很多应用程序，你希望这些应用程序的用户数据可以通过单点登录（Single Sign On）的方式互通。",
        list4:
          "你做了一个 JavaScript 前端应用和一个移动端应用，你希望这两个客户端应用都可以安全的访问你的 API。",
        list5: "你需要做一个支持 SAML 登录的 Web 应用程序。",
        list6:
          "你觉得密码非常脆弱，所以你想让用户使用一次性的手机验证码或邮箱验证码登录。",
        list7:
          "如果你用户的密码在其他网站上被泄漏了，你希望能得到通知，以便你通知你的用户去重置密码。",
        list8:
          "如果有用户连续登录失败，你希望禁止他们的 IP，以防止 DDOS 攻击或暴力破解密码。",
        list9:
          "你在一家大型企业中，该企业希望联合其现有的企业目录，以允许员工使用其现有的企业凭据登录各种内部和第三方应用程序。",
        list10:
          "你不想（或者你不知道如何）实现自己的用户管理解决方案。也不想开发密码重置，创建，配置，阻止和删除用户这些重复性的 UI，你只想专注于你自己的业务研发和产品设计，这时你可以选择 Authing 作为认证中间件。",
        list11: "你希望在用户想要访问敏感数据时强制执行多重身份验证。",
        list12:
          "你正在寻找一种身份解决方案，可以帮助你兼容 SOC2，GDPR，OpenID Connect 等不断增长的合规性要求。",
        list13:
          "你希望使用数据分析来跟踪你网站或应用上的用户，同时希望使用此数据拓展获客渠道，衡量用户留存率并逐步改善注册流程。",
      },
    },
  },
  auth0: {
    banner: {
      title: "全面替代 Auth0",
      description: `在中国，使用 Auth0 会遇到不少「水土不服」的难题。为此，Authing 身份云推出「替代 Auth0 解决方案」，能满足企业与开发者的国产化需求。`,
      solution: "下载解决方案",
      consult: "方案咨询",
    },
    replace: {
      title: "为什么选择 Authing 替代 Auth0？",
      subtitle: "进入中国市场，需要更加本土化的身份认证与访问管理服务。",
      authing: {
        title: "使用 Authing",
        subtitle: "享受更加本土化的服务",
        item1: {
          title: "响应速度快捷",
          descript:
            "Authing 身份云已经在全球多个节点进行部署，静态文件采用阿里云 CDN 全球加速；无论国内或国外，平均响应时间仅需 500 毫秒。",
        },
        item2: {
          title: "应用生态完备",
          descript:
            "Authing 身份云预集成多种海内外常见身份源，包括微信、支付宝、微博、Google、Apple、Twitter 等，5 分钟即可完成配置。",
        },
        item3: {
          title: "云服务选择多元",
          descript:
            "Authing 身份云支持华为云、阿里云、腾讯云、亚马逊云、微软云等多云部署，完全「云中立」，企业有更多元的云生态选择。",
        },
        item4: {
          title: "客户服务活跃",
          descript:
            "针对企业客户，Authing 身份云提供专属的客户成功经理，平均能在 20 分钟内进行响应；而针对个人开发者，也有完善的开发者论坛，为用户答疑解惑。",
        },
      },
      auth0: {
        title: "使用 Auth0",
        subtitle: "面临中国本土化的挑战",
        item1: {
          title: "响应速度缓慢",
          descript:
            "Auth0 在全球拥有良好的口碑，但尚未进入中国市场，因此在国内的平均响应时间较长，需 2.7 秒左右。而缓慢的响应速度将影响用户体验。",
        },
        item2: {
          title: "第三方身份源缺失",
          descript:
            "Auth0 缺乏对本土化「第三方身份源」的支持，如微信、支付宝等。但在中国，通过这些应用进行第三方登录，必不可少。",
        },
        item3: {
          title: "云部署支持有限",
          descript:
            "Auth0 支持部署于亚马逊云和微软云，但尚未支持国内大量企业选择的阿里云、腾讯云、华为云等本地云服务提供商。",
        },
        item4: {
          title: "售后服务受制",
          descript:
            "目前，Auth0 在中国尚未提供官方的支持服务，社区响应速度较慢，且有天然的时差限制。",
        },
      },
    },
    table: {
      title: "使用 Authing，打造对标硅谷的身份建设",
      description1:
        "与 Auth0 相比，Authing 身份云提供了同样完善的 IDaaS 能力，及 1000+ 开发者友好的 API/SDK；",
      description2: "并且能用更低的成本，成就更好的效果。",
      learnMore: "了解更详尽的功能对比",
      fun: "功能",
      fun1: "定价",
      fun2: "微信/支付宝等国内生态",
      fun3: "自定义密码加密",
      fun4: "ABAC",
      fun5: "SaaS 版本",
      fun6: "私有化部署",
      fun7: "用户管理后台",
      fun8: "自定义 OIDC、SAML 等作为 ldp",
      fun9: "多租户",
      fun10: "M2M",
      fun11: "单点登录",
      fun12: "MFA",
      auth0Remark: "仅企业版提供",
      authingRemark: "高级版/企业版皆提供",
    },
    transfer: {
      title: "方案成熟可靠，迁移 0 负担",
      description1:
        "在海外使用 Auth0 的企业，如何将身份系统从 Auth0 迁移至 Authing，以便更高效的进入中国市场？",
      description2: "对此，我们已验证多次最佳实践。",
      consult: "立即咨询",
      step1: {
        title: "评估迁移成本",
        subtitle:
          "例如，我们曾帮助某全球拥有 20000 MAU 、3 款 app 的元宇宙社交平台迁移数据至 Authing。首先，我们将从用户和角色信息、权限信息、应用信息、SDK 等维度进行成本分析。",
      },
      step2: {
        title: "迁移存量数据",
        subtitle:
          "为保证替代 Auth0 的方案不影响原有业务，Authing 通过两方的 API 将对应的用户数据、角色数据、应用数据、权限数据结构打通，尽可能减低迁移成本。",
      },
      step3: {
        title: "同步增量数据",
        subtitle:
          "对于业务方，替代系统需要一个转换过程。因此，针对增量数据的同步，Authing 通过双方支持的底层接口，可基于事件或基于定时器进行同步，让使用上的转换更无负担。",
      },
      step4: {
        title: "无痛完成迁移",
        subtitle:
          "迁移至 Authing，对进入中国市场的企业来说，能更好地满足中国的数据安全与合规条款。并且通过 Authing 提供的 API/SDK，能更安全高效的达到快速上线、打通用户数据的目的。",
      },
    },
  },
  okta: {
    banner: {
      title: "全面替代 Okta",
      description: `Authing 能全面覆盖 Okta 提供的身份中台、用户目录、身份开发组件等功能，并且更符合中国大陆的市场需求。目前，已有不少企业选择以 Authing 替换 Okta。`,
      solution: "下载解决方案",
      consult: "方案咨询",
    },
    replace: {
      title: "为什么选择 Authing 替代 Okta？",
      subtitle: "进入中国大陆市场，需要更加本土化的身份认证与访问管理服务。",
      okta: {
        title: "使用 Okta",
        subtitle: "面临中国本土化的挑战",
        item1: {
          title: "合规要求不符",
          descript:
            "中国大陆地区的法规对安全合规和用户数据保护有严格的要求。在国内直接使用 Okta，需自行解决多项合规问题。",
        },
        item2: {
          title: "响应速度缓慢",
          descript:
            "Okta 尚未进入中国大陆市场，在国内的平均响应时间较长，延迟性高，将影响用户登录的体验。",
        },
        item3: {
          title: "第三方身份源缺失",
          descript:
            "Okta 缺乏对本土化「第三方身份源」的支持，如微信、支付宝等。但在中国，通过这些应用进行第三方登录，必不可少。",
        },
        item4: {
          title: "售后服务受制",
          descript:
            "目前，Okta 在中国大陆地区尚未提供官方的支持服务，社区响应速度较慢，且有天然的时差限制。",
        },
      },
      authing: {
        title: "使用 Authing",
        subtitle: "享受更加本土化的服务",
        item1: {
          title: "数据安全合规",
          descript:
            "Authing 拥有 ISO、三级等保、GDPR 等数据安全认证，并在上线之初，就被录入《中国网络安全产业白皮书》。",
        },
        item2: {
          title: "响应速度快捷",
          descript:
            "Authing 身份云已在全球多个节点进行部署，静态文件采用阿里云 CDN 全球加速；无论国内或国外，平均响应时间仅需 500 毫秒。",
        },
        item3: {
          title: "应用生态完备",
          descript:
            "Authing 身份云预集成多种海内外身份源，包括微信、支付宝、微博、Google、Apple、Twitter 等，5 分钟即可完成配置。",
        },
        item4: {
          title: "客户服务活跃",
          descript:
            "针对企业客户，Authing 提供专属的客户成功经理，平均能在 20 分钟内进行响应；而针对个人开发者，也有完善的开发者论坛，为用户答疑解惑。",
        },
      },
    },
    marquee: {
      item1: {
        title1: "某全球知名在线教育平台",
        desc1:
          "该平台不仅开放各种课程，更开放了教学的机会；目前已服务了 180 个国家的 7800 万用户",
        title2: "快速打通海内外第三方身份源",
        desc2:
          "拓展中国大陆市场，登录系统不仅需要满足严苛的合规要求，还需打通微信、微博等应用登录，但 Okta 尚未提供相关支持。Authing 完善的产品功能和专业的服务团队，帮助我们在有限的时间内快速落地，为我们拓展本地的在线教育业务打下了了扎实的基础。",
      },
      item2: {
        title1: "Alpha Cen",
        desc1:
          "源自美国硅谷，具备从底层材料和器件创新，到芯片设计和稳定大量出货终端产品的全栈研发能力",
        title2: "高效统一海内外身份认证管理",
        desc2:
          "基于硅谷大厂的经验，我们深知统一身份管理的重要性。因此，回国后，我们积极寻找能对标 Okta 服务的身份认证管理产品。Authing 提供了各类工程软件及平台的接口，文档详细且易读。这使我们只需用很少的精力，就能搭建起完整的身份认证管理平台。",
      },
      item3: {
        title1: "某国内知名跨境物流服务商",
        desc1:
          "专注国际物流近 10 年，接收处理的包裹达上百万，成功开拓海外各地区的专线空派及海派业务",
        title2: "便捷提升海内外用户登录体验",
        desc2:
          "我们曾考虑在中国大陆地区使用 Okta，但因为延迟性高、登录体验感差而退却，选择了 Authing。Authing 在海内外提供同等性能的服务，并具备积极响应的客户成功团队、高度完善的技术文档供参考，能帮助我们实现国内外系统的统一。",
      },
    },

    table: {
      title: "使用 Authing，高效拓展全球业务",
      description1: "与 Okta 相比，Authing 身份云提供了同样完善的 IDaaS 功能，",
      description2: "并具备更多满足中国本土化需求的能力。",
      learnMore: "查看更多对比",
      showDemo: "预约演示",
      remark: "不确定",
      fun: "功能",
      fun1: "微信、支付宝等国内应用",
      fun2: "中国大陆地区的官方服务",
      fun3: "SMS OTP 在中国大陆地区的抵达率",
      fun4: "SMS OTP 在中国大陆地区的抵达时间",
      fun5: "阿里云、华为云等中国云服务",
      fun6: "Google、Apple ID 等海外应用",
      fun7: "用户管理 API",
      fun8: "多种开发语言的预集成 SDK",
      fun9: "OIDC、SAML、CAS、Oauth2.0",
      fun10: "自定义密码策略",
      fun11: "自动化身份同步",
      fun12: "Webhooks 提醒",
      fun13: "自定义域名",
      fun14: "人脸识别",
      fun15: "自定义、自动化的身份管理 workflow",
      fun16: "角色和权限、M2M",
      fun17: "单点登录",
      fun18: "MFA",
    },
  },
};
